<template lang="pug">
  .vip-v2-container(:class="containerClass")
    div(v-if="haveData" :style="topStyle" :class="tabCode==='ladder'?'haveData':''")
      //- 下架通知公告栏
      .down-version-banner-container(v-if="downPropVersion && showDownVersionBanner")
        AdvResource(
          resourceId="2e14d0073134483dbaf90cd4737c6034"
          :borderRadius="16"
          @advEvent="handleDownVersionBannerEvent"
        )
      component(
        v-for="(item, index) in componentsData"
        :key="index"
        :is="item.component"
        :class="item.className"
        v-bind="item.props"
        v-if="item.condition"
        @refresh="refreshAward"
        @useCard="useCoupon"
        @useRide="firstStatus"
        @click-btn="firstStatus"
        @open-exchange="openExchangeBlock"
        @openExtend="openExchangeData"
        @openRecord="openRecord"
        @refreshData="refreshData"
        @showRenwalRide="showModal"
        @openModal="openTriallModal"
        @openAutoRenew="openAutoRenew"
        @gourl="goUrl(config.deepLink, true)"
      )
      .under-block(v-if="!getRide()")
        .ladder-coupon(v-if="getLadder()&&ladderDetailMap")
          ladder-coupon-block(
            @clickReceiveButton="(couponInfo)=>{ this.firstStatus(couponInfo)}"
            :groupList="groupList"
            :ladderDetailMap="ladderDetailMap"
            :ladderPropGroupList="ladderPropGroupList"
            @notInAppJump="goUrl"
            )
        div(v-else)
          .first-block
            img.first(src="https://m.hellobike.com/resource/helloyun/08345/LMF85SEp9p.png?x-oss-process=image/quality,q_80")
            .first-top-block
              .first-top-block-title {{groupsOne?groupsOne.title:''}}
            .first-bottom-block
              .first-list(v-if="groupsOne && groupsOne.coupons")
                .first-item(v-for="(item,index) in groupsOne.coupons"
                :style="(item.status !== 1 && item.status !== 2)?op7:''")
                  .first-title-block
                    .first-title-block-img
                      img(:src="item.propIcon||'https://m.hellobike.com/resource/helloyun/08345/8c3GjVDzUV.png?x-oss-process=image/quality,q_80'")
                    .first-title-block-businessKey {{item.goodsPropDesc}}
                  .first-money-block
                    .bigMoney {{getBigMoney(item.amount)}}
                    .smallMoney {{getSmallMoney(item.amount)}}
                    .moneyUnit {{item.unit}}
                    .moneyUnit.twoPX x
                    .moneyProp {{item.propNum}}
                    .moneyUnit 张
                  .first-word-block {{item.subtitle}}
                  .first-status(@click="firstStatus(item)") {{getName(item.btnName)}}
          .second-block(v-for="(item,index) in groupsOther")
            coupon-more.coupon-more(
              :info="item"
              :indexs="index"
              @receive="openReceiveModal",
              @use="useCoupon"
              @wait="waitCoupon")
      equityComparison(v-if="ride_trial_verison")
      .other-block(v-if="otherList.length>0")
        .other-block-item(v-for="(item,index) in otherList")
          img.under-img(
            :src="getImageUrl(item.bonusEntity && item.bonusEntity.payedImage)"
            @click="goOther(item)")
      ViewportLazyRender(
        v-if="env.isEasyBikeApp && externalInfo && showLottery"
        :placeholder="true"
      )
        ExternalRights(:externalInfo="externalInfo")
        template(slot="placeholder")
          ExternalRightsSkeleton
      .no-use(v-if="fullRefundUnusedShowAb" @click="showNoUse")
        .no-use-left
          img.no-use-img(:src="noUseImgSrc")
          div 未使用包退
        .no-use-right(:class="getNouseStyle()")
          span {{getNoUseWord()}}
          img.no-use-flag(:src="noUseFlagSrc")
      quark-compass-nps-base.free-quark-nps-base(
        :env="Env"
        v-if="showSinan"
        :token="token"
        pagefrom="super-member"
        validate-score-only
        :systemcode="systemCode"
        :extend-info="npsExtendInfo"
        :survey-id="surveyId"
        :code-key="codeKey"
        @load="loadSinan"
        @success="handleNpsSuccess"
      )
      qaAndSuggest(:showQa="showQa" @goQa="goQa" @goSuggest="goSuggest")
      .rule-block(v-if="!freeRightsVersion() && !env.isEasyBikeApp")
        span(style="margin-right:0.02rem" @click="clickMenu(0)") 规则协议
        span |
        span(style="margin-left:0.02rem" @click="clickMenu(1)") 购买记录
        span |
        span(style="margin-left:0.02rem" @click="clickMenu(2)") 客服中心
      .shark-block(v-if="haveData && !freeRightsVersion()")
    //- div.no-data-block(v-else)
    //-   .nodata-img
    //-     img.noData(src="https://m.hellobike.com/resource/helloyun/08345/ptrfD33uJv.webp")
    //-   .noData-word 即将进入超级会员…
    tip-modal(ref="tipModal" :mainTitle='mainTipTitle' :subTitle='subTipTitle')
    renewal-popup-ride(
      v-if="showRenwalRide"
      :show.sync="showRenwalRide"
      :expirationDate="expirationDate"
      :remainDays="remainDays"
      :continuousCornerMark="mobileOperatorCustomizeInfoDTO && mobileOperatorCustomizeInfoDTO.continuousCornerMark || ''"
      @open="bayCardHandler"
      :commonBonus="commonBonus"
      @close="closeScroll"
    )
    Skeleton
    noPay(ref="nopay"
    :show="showNopay"
    :transType="transType"
    :noPayData="noPayData||{}"
    @refresh="refreshNopay"
    @close="closeNew"
    @open="bayCardHandler"
    @cancelOrder="cancel")
    onePageUpModal(
      ref="onepageup"
      :type="2"
      :info="price"
      :time="price.couponEndTime||0"
      :autoRenewalStatus="autoRenewalStatus"
      :commonBonus="commonBonus"
      @closeOnePage="closeScroll")
    .feedback-button( @click.stop="openFeedbackPopup" v-if="isShowFeedbackEntry")
      img.icon(src="https://m.hellobike.com/resource/helloyun/22042/c7oF6kDkK-.png")
      .text 评价
    feedback-popup(
      v-if="showFeedback"
      :show.sync="showFeedback"
      @close="closeScroll"
      @submit="feedbackSubmit")
    receive-packet(v-if="showLadderCoupon"
      :show.sync="showLadderCoupon"
      :couponInfo="bigCouponInfo"
      @goToUse="goToLadderUse"
      @refresh="getData"
  )
    equityModal(v-if="showEquityModal"
      :show.sync="showEquityModal"
      :couponInfo="openModalData"
      :isExpansiveSuccess="isExpansiveSuccess"
      @goToUse="goToModalUse"
      @refresh="getData"
  )
    guideModal(v-if="showGuideModal"
      :show.sync="showGuideModal"
      :couponInfo="openModalData")
    externalInterestModal(v-if="showExternalInterest"
    :show.sync="showExternalInterest"
    :couponInfo="openModalData"
  )
    signModal(v-if="showSignModal"
      :show.sync="showSignModal"
      :couponInfo="openModalData")
    taskModal(v-if="showTaskModal"
      :show.sync="showTaskModal"
      :couponInfo="openModalData")
    openNewCustomer(v-if="showOpenNewCustomer&&env.isEasyBikeApp"
      :show.sync="showOpenNewCustomer"
      :couponInfo="openModalData")
    priceReductionRenewal(v-if="showPriceReductionRenewal"
      :show.sync="showPriceReductionRenewal"
      :info="renewSendCouponData"
      :time="renewSendCouponData.couponEndTime || 0"
      @buyContinue="bayCardHandler")
    noUseOpenBlock(:show.sync="showNoUseBlock" @showRefundBlock="showRefundmodal")
    refundBlock(:show.sync="showRefund" :isNewMember="true")
    checkRefund(:show.sync="showCheckService" :nextRefundDays="nextRefundDays"
    :refundTime="refundTime")
    refundRule(:show.sync="checkRule" :useVipDetails="useVipDetails")
    visit-page-countdown(
      :env="Env"
      )
    //- vipButtontrial(
    //-   v-if="haveData&&ride_trial_verison&&!isNextCycleCharged&&needDayTips"
    //-   ref="buttonNew",
    //-   :info="trial_info",
    //-   @open="bayCardHandler",
    //-   @openDialog="openDialog",
    //-   :isIndex="true"
    //-   )
    changeRecord(:show.sync="showChangeRecord" :vipRecordGuid="vipRecordGuidData")
    exchangeBlock(:show.sync="showExchangeBlock"
      :groups="exchangeList"
      :couponGameAB="couponGameAB"
      @changeIt="changeIt")
    changeExpansionCardModalContainer(v-if="showChangeModal"
      :show.sync="showChangeModal"
      :openChangeType="openChangeType"
      :goodsGuid="goodsGuid"
      :couponInfo="changeValue"
      :vipRecordGuid="vipRecordGuidData"
      :propVersion="propVersion"
      :extandData="extandData"
      @click-btn="firstStatus"
      @success="changeSuccess"
      @refresh="getData")
    multiCouponsSelectModal(
    :visible.sync="showMultiCoupon"
    :couponList="multiCouponList"
    @click-btn="firstStatus")
    winning-dialog(
      :show.sync="showWinningDialog"
      :winningData="winningData"
      :currentOrderOptType="currentOrderOptType"
    )
    NoWinDialog(
      :show.sync="showNoWinDialog"
      :dialogData="noWinData"
      :currentOrderOptType="currentOrderOptType"
    )
    buyMemberModal(
      ref="buyMemberModal"
      :show.sync="showBuyMemberModal" :buyMemberData="trial_propList"
      :isReadProp="isRead"
      :rideTrialUpgradeAB="rideTrialUpgradeAB"
      :isnew="true"
      @showRead="showReadFn"
      @transType="getTransType"
      @openDialog="openSuccess"
      :propVersion="propVersion"
      )
    readModal(
      :show="showRead"
      @close="showRead=false"
      @readOk="readOk"
  )
    renewalManagementModal(
      v-if="showRenewalManagementModal"
      :show.sync='showRenewalManagementModal'
      :unionVip="unionData"
      @refresh="refreshData")
    member-guide-modal(
      :show.sync="showGuide"
      @close="closeGuide"
    )
    //- 下架通知弹窗
    .down-version-popup-container(v-if="downPropVersion && showDownVersionPopupVisible")
      AdvResource(
        resourceId="f54b33b131cc4389ac74f7e19d5147f2"
        @advEvent="handleDownVersionPopupEvent"
      )
  </template>

<script>
import '@hb/task-h5-components/lib/countdown/visit-page';
import '@hb/compass-nps';
import config from '@/const/config';
import Toast from '@/components/toast';
import { OrderOptType, ORDER_TYPE } from '@/pages/vip/consts.js';
import CommonHeader from '@/components/common-middle-header';
import {
  getVipStatus, receiveVipCoupon, buyVipGoods, tryTakeOrderStatus, getWaitPayOrder,
  closeVipGoods, getTaurusAward, isShowFeedback, submitFeedback,
  showQa, openWindow, getCancelUserVipPropInfo, getBenifitsInReopen,
} from '@/api/vip';
import { Native, env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getTokenAndKey, tryCatch, isPreRender, getTokenAndLocation, getNoScroll,
} from '@/utils';
import { CardService } from '@/service/card';
import { Storage } from '@/utils/storage';
import deepCopy from '@/utils/deepCopy';
import { getImageUrl } from '@/utils/image';
import Loading from '@/components/loading';
import Skeleton from '@/components/skeleton.vue';
import PopMenuButton from '@/components/pop-menu-button';
import { startApp } from '@/utils/index';
import Picture from '@/components/picture';
import { Navigator } from '@hb/h5-navigator';
import { PropVersionMap } from '@/const/vip';
import ViewportLazyRender from '@/components/viewport-lazy-render.vue';
import ladderCouponBlock from '../ladder-coupon-block';
import transTab from '../transTab';
import {
  COUPON_STATUS,
  RENEWAL_STATUS,
  ORDER_STATUS,
  VERISON_SHOW_MAP,
} from '../../../consts';
import CouponMore from '../coupon-more.vue';
import { getSource } from '../../../../../utils';
import {
  getSystemCode,
  // getVersion
} from '../../../../../utils/systemCode';
import TipModal from '../tip-modal.vue';
import RenewalPopup from '../renewal-popup.vue';
import RenewalPopupRide from '../renewal-popup-ride.vue';
import noPay from '../noPay';
import onePageUpModal from '../one-page-up-modal';
import awardMoneyModal from '../award-money-modal';
import awardBlockNew from '../award-block-new.vue';
import feedbackPopup from '../feedback-popup';
import receivePacket from '../receive-packet';
import rideMouth from '../ride-mouth.vue';
import RideMonthNUnionVip from '../ride-month-n-union-vip.vue';
import rideCard from '../ride-card.vue';
import signModal from '../sign-modal.vue';
import taskModal from '../task-modal.vue';
import equityModal from '../equity-modal.vue';
import { ParamsUtil } from '../../../../../utils/params';
import openNewCustomer from '../open-new-customer.vue';
import plusGift from '../plus-gift.vue';
import noUseOpenBlock from '../no-use-open-block.vue';
import refundBlock from '../refund-block.vue';
import checkRefund from '../check-refund.vue';
import refundRule from '../refund-rule.vue';
import priceReductionRenewal from '../price-reduction-renewal.vue';
import rewardPrivilege from '../reward-privilege';
import qaAndSuggest from '../qa-and-suggest.vue';
import equityComparison from '../equity-comparison.vue';
import rideExperienceCard from '../ride-experience-card.vue';
import vipButtontrial from '../vip-button-trial.vue';
import sinanBlock from '../sinan-block.vue';
import { CouponMapper, getSignChannelsData, shouldShowByDailyFrequency, markDailyFrequencyShown } from '../../utils';
import changeRecord from '../change-record.vue';
import changeExpansionCardModalContainer from '../change-expansion-card-modal.vue';
import exchangeBlock from '../exchange-block.vue';
import openMemberTop from './open-member-top.vue';
import memberOpenGift from '../member-open-gift.vue';
import guideModal from '../guide-modal';
import externalInterestModal from '../externalInterest-modal.vue';
import multiCouponsSelectModal from '../multi-coupons-select-modal.vue';
import newCustomer from '../new-customer-counpon.vue';
import buyMemberModal from './buy-member-modal.vue';
import readModal from '../read-modal.vue';
import renewalManagementModal from '../renewal-management-modal.vue';
import Lottery from '../lottery.vue';
import winningDialog from '../winning-dialog.vue';
import memberGuideModal from './guide-modal.vue';
import NoWinDialog from '../no-win-dialog.vue';
import NewLotteryNAward from '../new-lottery-n-ward.vue';
import FreeRights from './free-rights.vue';
import ExternalRights from './external-rights.vue';
import ExternalRightsSkeleton from './external-rights-skeleton.vue';
import AdvResource from './adv-resource.vue';

const UNDER_ONE = 'underOne';

const menus = [
  {
    name: '规则协议',
    icon:
      'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/bf77f80d-7f44-432a-97b2-a1b4a2027ae0.svg',
  },
  {
    name: '购买记录',
    icon:
      'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/5cdbe2d7-c086-4394-8012-80beb4b09fa6.svg',
  },
  {
    name: '客服中心',
    icon:
      'https://m.hellobike.com/resource/helloyun/08345/5AuBPuFHil.svg',
  },
];

const TELEPHONE_BUSINESS = {
  fat: 'Hello0126',
  uat: 'Hello0295',
  pre: 'Hello0030',
  pro: 'Hello0030',
};

export default {
  components: {
    transTab,
    CommonHeader,
    CouponMore,
    Skeleton,
    PopMenuButton,
    TipModal,
    RenewalPopup,
    noPay,
    onePageUpModal,
    awardMoneyModal,
    feedbackPopup,
    ladderCouponBlock,
    receivePacket,
    rideMouth,
    RideMonthNUnionVip,
    rideCard,
    RenewalPopupRide,
    Picture,
    signModal,
    taskModal,
    equityModal,
    openNewCustomer,
    plusGift,
    awardBlockNew,
    noUseOpenBlock,
    refundBlock,
    checkRefund,
    refundRule,
    qaAndSuggest,
    equityComparison,
    priceReductionRenewal,
    rewardPrivilege,
    vipButtontrial,
    rideExperienceCard,
    sinanBlock,
    changeRecord,
    changeExpansionCardModalContainer,
    exchangeBlock,
    openMemberTop,
    memberOpenGift,
    guideModal,
    multiCouponsSelectModal,
    newCustomer,
    buyMemberModal,
    readModal,
    renewalManagementModal,
    externalInterestModal,
    winningDialog,
    Lottery,
    memberGuideModal,
    NewLotteryNAward,
    NoWinDialog,
    FreeRights,
    ExternalRights,
    ViewportLazyRender,
    ExternalRightsSkeleton,
    AdvResource,
  },
  props: {
    openedData: {
      type: Object,
      default: () => { },
    },
    downPropVersion: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['freeRightsVersion', 'latestTabCode'], // 从父组件注入freeRightsVersion
  data() {
    return {
      showDownVersionBanner: true,
      showDownVersionPopupVisible: false,
      planId: '',
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true&chInfo=ch_share__chsub_CopyLink&fxzjshareChinfo=ch_share__chsub_CopyLink&apshareid=DAEF5627-8D33-4E6E-9CE2-2A0FD137329B&shareBizType=mrfxzw',
        wechatLink: 'https://m.hellobike.com/mf/spa/u_sxnpet/latest/MA2412037285359647643402840.html?activityCode=MA2412037285359647643402840',
      },
      groupsOne: [],
      commonBonus: [],
      otherList: [],
      groupsOther: [],
      groups: [],
      save: '',
      openVip: false,
      expirationDate: 0,
      usablePropAmount: null,
      discountAmount: null,
      otherCoupon: null,
      toReceiveCoupon: null,
      businessCoupon: null,
      willGuide: false, // 设置了引导弹窗
      menus,
      env,
      Env: config.env,
      showRenwal: false, // 会员续费浮层
      showRenwalRide: false, // 随心骑续费
      showWinningDialog: false, // 中奖弹窗
      winningData: {},
      showNoWinDialog: false, // 未中奖弹窗
      noWinData: {}, // 未中奖数据
      remainDays: 0,
      autoRenewalStatus: '',
      RENEWAL_STATUS,
      mainTipTitle: '',
      subTipTitle: '',
      // showPopUpWindowType: 0,
      showNopay: false,
      noPayData: {},
      renewalPrice: null, // 连续续费次月金额
      price: {
        couponEndTime: 0,
      },
      status: { ...COUPON_STATUS },
      upgradeNoticeDate: null,
      vipStartTime: null,
      transType: 30,
      haveData: false,
      op7: 'opacity: 0.4;',
      showAwardList: true,
      recordTotalReceiveBonusNum: '0',
      awardList: [],
      rewardTaskGuidanceList: [],
      isShowFeedbackEntry: false,
      showFeedback: false, // 评价打分浮层
      groupList: [],
      ladderDetailMap: null,
      ladderPropGroupList: [],
      unOpenShowCanBuy: null,
      ladderReceiveCoupon: null,
      showLadderCoupon: false,
      bigCouponInfo: {},
      showQa: false,
      goodsGuid: null,
      propVersion: '',
      appCode: null,
      showSignModal: false, // 展示签到弹窗
      showTaskModal: false, // 展示任务弹窗
      showEquityModal: false,
      openModalData: {},
      showOpenNewCustomer: false,
      plusGiftList: [],
      currentOrderOptType: null,
      openPopup: false,
      showSinan: true,
      systemCode: null,
      token: null,
      surveyId: null,
      codeKey: null,
      didSignToday: false, // 是否已签到
      bountyCountToday: null, // 今日签到可得奖励金数
      bountyCountYesterday: null, // 昨天签到奖励金个数
      signRemainDays: null, // 剩余签到天数
      remainBountyCount: null, // 剩余奖励金个数
      signShowStyle: false, // 新老奖励金ab
      points: null, // 总计
      isNextCycleCharged: null, // 是否下周期已经扣费
      nextPeriodBenefitStartTime: null, // 下个周期开始时间
      isRefund: false,
      refundTime: null,
      showNoUseBlock: false,
      showRefund: false,
      checkRule: false,
      showCheckService: false,
      nextRefundDays: null,
      useVipDetails: [],
      fullRefundUnusedShowAb: false,
      versionMap: VERISON_SHOW_MAP,
      componentsData: [], // 组件排序数组
      ride_trial_verison: false, // 单车体验版
      trial_info: {},
      showPriceReductionRenewal: false,
      renewSendCouponData: {},
      allTotalShow: '',
      showChangeRecord: false,
      showExchangeBlock: false,
      couponGameAB: '',
      exchangeList: [],
      extandData: {},
      showChangeModal: false,
      openChangeType: null, // 膨胀卡券类型 1.多选1
      changeValue: null,
      vipRecordGuidData: null,
      isExpansiveSuccess: false, // 膨胀变大成功
      loadingTimer: null,
      vipRecordGuid: null,
      giftData: null,
      needDayTips: null,
      showGuideModal: null,
      showMultiCoupon: false,
      multiCouponList: [],
      newCustomerData: {},
      showBuyMemberModal: false,
      buyMemberData: {},
      showRead: false,
      trial_propList: {},
      rideTrialUpgradeAB: 'N',
      isRead: false,
      showRenewalManagementModal: false,
      showExternalInterest: false,
      lotteryData: {},
      showGuide: false,
      userInfo: {},
      waitReceiveBonusNum: null,
      freeRightsData: {},
      unionData: {},
      isShowUnionRights: false,
      payActivityInfo: {},
      mobileCharge: {},
      mobileChargeCoupon: {},
      payingFlag: false, // 正在支付标识符
      curloopIntervalSecond: 0, // 轮询计数器
      orderTimer: null, // 轮询定时器引用
      externalInfo: {},
      mobileOperatorCustomizeInfoDTO: {},
    };
  },
  // 弹窗枚举
  // remindReceiveProp","待领取权益提示"
  // remindToUseProp","待核销权益提示",
  // "renewTips","续费提醒",
  // "ladderTaskTips","阶梯任务提醒",
  // "welfareSignIn","福利中心签到提醒"
  computed: {
    tabCode() {
      return this.latestTabCode();
    },
    topStyle() {
      if (this.tabCode === 'ladder' && !env.isEasyBikeApp) {
        return 'margin-top: 0.16rem;';
      }
      return '';
    },
    text() {
      const { discountAmount, usablePropAmount } = this;
      if (typeof discountAmount === 'number') {
        return `${discountAmount > 0
          ? `还有${usablePropAmount}元省钱券未使用` : `本月${usablePropAmount}元省钱券待使用`}`;
      }
      return '';
    },
    /** 是否展示日日抽
     * 版本控制：除普通权益外都显示
     */
    showLottery() {
      if (this.propVersion) {
        return ![PropVersionMap.NORMAL].includes(this.propVersion);
      }
      return false;
    },
    /** 是否展示日日抽新样式 */
    lotteryNewVersion() {
      if (this.showLottery) {
        return true;
      }
      return false;
    },
    /** 是否展示奖励金 */
    showAwardBlock() {
      return this.showAwardList
        && this.allTotalShow === 'N'
        && !this.lotteryNewVersion;
    },
    npsExtendInfo() {
      return JSON.stringify({
        port: this.systemCode,
        adsource: getSource(),
        propVersion: this.propVersion,
      });
    },
    // 动态判断是否添加类名base-class和free-rights-version类名
    containerClass() {
      const baseClass = this.tabCode !== 'ladder' ? 'bikeContainer' : '';
      const freeRightsClass = this.freeRightsVersion() ? 'free-rights-version' : '';
      return [baseClass, freeRightsClass].filter(Boolean);
    },
    // 根据版本动态获取图片URL
    noUseImgSrc() {
      return this.freeRightsVersion()
        ? 'https://m.hellobike.com/resource/gallery/1022/vCfFiRI1Uw.png'
        : 'https://m.hellobike.com/resource/gallery/61/1L7fasp87l.png';
    },
    noUseFlagSrc() {
      return this.freeRightsVersion()
        ? 'https://m.hellobike.com/resource/gallery/1022/F2bpVKe8_Path%205%20(1).png'
        : 'https://m.hellobike.com/resource/gallery/61/ZPRWm4DbLm.png';
    },
  },
  watch: {
    downPropVersion: {
      immediate: true,
      handler(val) {
        if (val && shouldShowByDailyFrequency('vip_down_version_popup_shown_date')) {
          this.showDownVersionPopupVisible = true;
        }
      },
    },
    openedData: {
      deep: true,
      immediate: false,
      handler(val) {
        this.vipData = val;
        this.getData();
      },
    },
    propVersion: {
      handler() {
        this.getSignChannelsData();
      },
    },
  },
  provide() {
    return {
      getPropVersion: () => this.propVersion,
      openSelectModal: this.openSelectModal,
      rideOneCentVersion: () => '', // 一分骑版本信息，此处未提供值，仅兜底
    };
  },
  beforeRouteEnter(to, form, next) {
    UBT.pageView({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      businessInfo: {
        adsource: getSource(),
      },
    });
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_newrules2',
      contentId: 'platform_newrules2',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_buycardrecord',
      contentId: 'platform_buycardrecord',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
  },
  beforeRouteLeave(to, form, next) {
    UBT.pageViewOut({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
  },
  async created() {
    document.title = '超级会员';
    if (getSystemCode) {
      this.systemCode = getSystemCode().toString();
    }
    if (env.isEasyBikeApp) {
      const hasVisitedMemberPage = sessionStorage.getItem('hasVisitedMemberPage') === 'true';
      if (!hasVisitedMemberPage) {
        window.history.pushState(null, '提示弹窗', document.URL);
        sessionStorage.setItem('hasVisitedMemberPage', 'true');
      }
      window.addEventListener('popstate', this.handleBackGuides);
      const showGuideTime = localStorage.getItem('showGuideTime');
      this.$emit('closeOpen', false);
      if (!showGuideTime) {
        localStorage.setItem('showGuideTime', 2);
      }
    }
    if (config.env === 'fat') {
      this.surveyId = 'bf2b9cb6388d40f5848399e4c8985d25';
      this.codeKey = 'bike_ABC';
    } else if (config.env === 'uat') {
      this.surveyId = '2c4337f30f244925a70966f3d931463d';
      this.codeKey = 'user_platform_super_nps';
    } else if (config.env === 'pro') {
      this.surveyId = 'e8a27ae85c574660aed6ddb3a6046ff7';
      this.codeKey = 'user_platform_super_nps';
    }
    const {
      finishPay, loopIntervalSecond,
      orderNo,
      loopTotalSecond,
    } = ParamsUtil.getParams(window.location.href);
    const { token } = await getTokenAndKey();
    if (finishPay) {
      this.searchStatus({
        loopIntervalSecond,
        orderNo,
        loopTotalSecond,
        token,
      }, null);
    }
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  async mounted() {
    this.vipData = deepCopy(this.openedData);
    document.title = '超级会员';
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    if (this.$refs.button) {
      this.$refs.button.locate();
    }
    await this.getWaitPayOrder();
    await this.getAwardList();
    if (!this.showNopay) {
      this.getOpenWindow();
      // 专属客服曝光
    }
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_user_service',
      contentId: 'platform_user_service',
      exposureTimes: 1,
      businessInfo: {},
    });
    const { isRenew } = ParamsUtil.getParams(window.location.href);
    if (isRenew === 'true') {
      Toast.show('自动续费已关闭');
    }
    await this.getData();
    this.getComponentsData();
  },
  destroyed() {
    this.loadingTimer = null;
    if (env.isEasyBikeApp) {
      window.removeEventListener('popstate', this.handleBackGuides); // false阻止默认事件
    }
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    getImageUrl,
    /**
     * AdvResource Banner 加载回调
     * onLoad 事件中 needShow 表示投放平台是否判定需要展示
     */
    handleDownVersionBannerEvent(event = {}) {
      const { type, data } = event;
      if (type === 'onLoad') {
        this.showDownVersionBanner = !!(data && data.needShow);
      }
    },
    /**
     * AdvResource 弹窗加载/关闭回调
     * - onLoad + needShow=true：弹窗确认展示，标记今日已展示（localStorage）
     * - onLoad + needShow=false：投放平台判定不展示，释放优先级锁
     * - onClose：用户关闭弹窗，释放优先级锁
     */
    handleDownVersionPopupEvent(event = {}) {
      const { type, data } = event;
      if (type === 'onLoad' && data && data.needShow) {
        // 弹窗确认展示，标记今日已展示，禁用页面滚动
        this.markDownVersionPopupShown();
        getNoScroll(true);
        return;
      }
      if ((type === 'onLoad' && data && !data.needShow) || type === 'onClose') {
        this.showDownVersionPopupVisible = false;
        getNoScroll(false);
        this.resolveDownVersionPopup();
      }
    },
    /**
     * 弹窗优先级控制：等待下架弹窗关闭后才允许后续弹窗弹出
     * 返回一个 Promise，在弹窗关闭或 10s 超时后 resolve
     * 调用方（getOpenWindow）通过 await 此方法实现"下架弹窗优先"
     */
    waitForDownVersionPopupClosed() {
      if (!this.downPropVersion || !this.showDownVersionPopupVisible) {
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        this._downVersionPopupResolve = resolve;
      });
    },
    /**
     * 统一收口：resolve Promise
     * 被 handleDownVersionPopupEvent 调用
     */
    resolveDownVersionPopup() {
      if (this._downVersionPopupResolve) {
        this._downVersionPopupResolve();
        this._downVersionPopupResolve = null;
      }
    },
    /**
     * 标记弹窗已展示（写入 localStorage，当天不再弹出）
     */
    markDownVersionPopupShown() {
      markDailyFrequencyShown('vip_down_version_popup_shown_date');
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.refreshData();
        this.getAwardList();
      }
    },
    handleNpsSuccess() {
      this.showSinan = false;
    },
    handleBackGuides(event) {
      let showGuideTime = localStorage.getItem('showGuideTime');
      showGuideTime = showGuideTime ? Number(showGuideTime) : 0;
      if (showGuideTime !== 0) {
        event.preventDefault();
        localStorage.setItem('showGuideTime', showGuideTime - 1);
        this.showGuide = true;
        getNoScroll(true);
        return;
      }
      this.closeGuide();
    },
    closeGuide() {
      getNoScroll(false);
      Native.closeWebView();
    },
    getSignChannelsData() {
      if ((env.isWeixin || env.isWechatMini) && this.propVersion) {
        this.planId = '';
        this.payActivityInfo = {};

        getSignChannelsData({ propVersion: this.propVersion })
          .then((res) => {
            if (res) {
              if (res && res.planIdMapping) {
                this.planId = res.planIdMapping.wechatTrust || '';
                this.payActivityInfo = res.payActivityInfo || {};
              }
            }
          })
          .catch(() => { });
      }
    },
    openAutoRenew() {
      this.showRenewalManagementModal = true;
    },
    showModal() {
      if ((this.ride_trial_verison && this.trial_propList && Object.keys(this.trial_propList).length > 0) || this.currentOrderOptType === 60) {
        this.showBuyMemberModal = true;
      } else {
        this.showRenwalRide = true;
      }
    },
    openSuccess(type, data) {
      if (type === 30) {
        this.mainTipTitle = '会员连续包月开通成功！';
        this.subTipTitle = `将在${data.sendAfterDays > 0 ? data.sendAfterDays : '明'}天后（当前会员到期后），发放本次续费会员的权益`;
        if (this.$refs.tipModal) {
          this.showRenwal = false;
          this.showRenwalRide = false;
          getNoScroll(false);
          this.$refs.tipModal.open();
          this.refreshData();
          // this.getData();
          this.getNoUse();
        }
      } else if (!data.isUpgrade) {
        this.mainTipTitle = '恭喜你，续费成功！';
        this.subTipTitle = `将在${data.sendAfterDays > 0 ? data.sendAfterDays : '明'}天后（当前会员到期后），发放本次续费会员的权益`;
        if (this.$refs.tipModal) {
          this.showRenwal = false;
          this.showRenwalRide = false;
          getNoScroll(false);
          this.$refs.tipModal.open();
          this.refreshData();
          // this.getData();
          this.getNoUse();
        }
      } else {
        this.mainTipTitle = '恭喜你，升级成功!';
        this.subTipTitle = '体验会员已升级为正式会员，权益已刷新请注意查看';
        if (this.$refs.tipModal) {
          this.showRenwal = false;
          this.showRenwalRide = false;
          getNoScroll(false);
          this.$refs.tipModal.open();
          // this.getData();
          this.refreshData();
          this.getNoUse();
        }
      }
    },
    readOk() {
      this.isRead = true;
      let openPrice;
      if (this.transType === 30) {
        // eslint-disable-next-line no-nested-ternary
        openPrice = this.trial_info.signInfoDTO ? (this.trial_info.signInfoDTO.firstSignPrice >= 0 ? this.trial_info.signInfoDTO.firstSignPrice : '-') : '-';
      } else if (this.transType === 60) {
        openPrice = 0;
      } else {
        openPrice = (this.trial_info.price >= 0 ? this.trial_info.price : '-');
      }
      this.bayCardHandler(null, this.transType, openPrice, this.trial_info.goodsGuid);
    },
    getTransType(val) {
      this.transType = val;
    },
    showReadFn() {
      this.showRead = true;
    },
    openTriallModal() {
      this.showBuyMemberModal = true;
    },
    openSelectModal(coupon) {
      if (coupon.status === this.status.locked) return;
      this.multiCouponList = coupon.allCoupons;
      this.showMultiCoupon = true;
    },
    openRecord() {
      this.showChangeRecord = true;
    },
    changeSuccess(val) {
      this.showEquityModal = true;
      this.openModalData = val;
      this.showChangeModal = false;
      this.showExchangeBlock = false;
      this.isExpansiveSuccess = true;
      this.refreshData();
    },
    changeIt(val, item) {
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_Exchange_coupons_choice',
        contentId: 'platform_Exchange_coupons_choice',
        exposureTimes: 1,
        businessInfo: {},
      });
      this.openChangeType = val;
      this.changeValue = item;
      this.showChangeModal = true;
    },
    openExchangeBlock(val) {
      this.showExchangeBlock = true;
      this.exchangeList = val;
    },
    openExchangeData(val) {
      // 膨胀券弹窗打开
      this.openChangeType = 3;
      this.showChangeModal = true;
      this.changeValue = val;
    },
    closeSinan() {
      this.showSinan = false;
    },
    openDialog() {
      this.getWaitPayOrder();
    },
    goSuggest() {
      this.showFeedback = true;
    },
    getNoUseWord() {
      if (this.isRefund) {
        return '服务生效中';
      } if (this.refundTime) {
        return '查看服务';
      }
      return '服务已失效';
    },
    showRefundmodal() {
      this.showRefund = true;
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_Double_confirmation_refund',
        contentId: 'platform_Double_confirmation_refund',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    showNoUse() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_refund2',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.showNoUseBlock = this.isRefund;
      if (this.showNoUseBlock) {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_Confirm_refund',
          contentId: 'platform_Confirm_refund',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
      this.showCheckService = !this.isRefund && this.refundTime;
      if (this.showCheckService) {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_refunded',
          contentId: 'platform_refunded',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
      this.checkRule = !this.isRefund && !this.refundTime;
      if (this.checkRule) {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_Equity_used',
          contentId: 'platform_Equity_used',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
    },
    getNouseStyle() {
      if (this.isRefund) {
        return 'black-no-use';
      }
      if (this.refundTime) {
        return 'black-no-use';
      } return '';
    },
    async getNoUse() {
      const { token } = await getTokenAndKey();
      try {
        const res = await getCancelUserVipPropInfo({
          token,
          appCode: 'platform',
        });
        if (res.data) {
          this.fullRefundUnusedShowAb = res.data.fullRefundUnusedShowAb;
          if (this.fullRefundUnusedShowAb) {
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_refund2',
              contentId: 'platform_refund2',
              exposureTimes: 1,
              businessInfo: {},
            });
          }
          this.isRefund = res.data.isRefund;
          this.refundTime = res.data.refundTime;
          this.nextRefundDays = res.data.nextRefundDays;
          this.useVipDetails = res.data.useVipDetails;
        }
        // eslint-disable-next-line no-empty
      } catch { }
    },
    loadSinan(val) {
      if (val.detail && val.detail.isDisplay) {
        this.showSinan = true;
      } else {
        this.showSinan = false;
      }
    },
    openSinan() {
      this.openPopup = true;
    },
    getRide() {
      if (this.propVersion) {
        return this.propVersion.includes(PropVersionMap.RIDE);
      }
      return false;
    },
    getLadder() {
      if (this.propVersion) {
        return this.propVersion.includes('ladder');
      }
      return false;
    },
    async getOpenWindow() {
      // 等待下架弹窗关闭后再执行
      await this.waitForDownVersionPopupClosed();

      const { isComplete } = ParamsUtil.getParams(window.location.href);
      const { token, cityCode } = await getTokenAndLocation();
      try {
        const res = await openWindow({
          reqScene: (isComplete === 'true') ? 'unOpenToOpened' : 'openedPage',
          token,
          systemCode: getSystemCode(),
        });
        if (!res.data || !res.data.infos || !res.data.infos.length) return;
        res.data.infos.forEach(async (i) => {
          if (i.sceneKey === 'remindReceiveProp' || i.sceneKey === 'remindToUseProp') {
            if (i.sceneKey === 'remindReceiveProp') {
              UBT.moduleExpose({
                pageId: 'platform_openedcard_page',
                categoryId: 'platform',
                moduleId: 'platform_equity_pop',
                contentId: 'platform_equity_pop',
                exposureTimes: 1,
                businessInfo: {},
              });
            }
            if (i.sceneKey === 'remindToUseProp') {
              UBT.moduleExpose({
                pageId: 'platform_openedcard_page',
                categoryId: 'platform',
                moduleId: 'platform_equity2pop',
                contentId: 'platform_equity2pop',
                exposureTimes: 1,
                businessInfo: {
                  businessType: '业务线',
                },
              });
            }
            this.openModalData = CouponMapper(i);
            this.showEquityModal = true;
          }
          if (i.sceneKey === 'ladderTaskTips') {
            this.openModalData = CouponMapper(i);
            this.showTaskModal = true;
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_task_pop',
              contentId: 'platform_task_pop',
              exposureTimes: 1,
              businessInfo: {
                businessType: i.businessLineName,
              },
            });
          }
          if (i.sceneKey === 'renewTips') {
            this.showRenwalRide = true;
            getNoScroll(true);
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_Renew_pop',
              contentId: 'platform_Renew_pop',
              exposureTimes: 1,
              businessInfo: {},
            });
          }
          if (i.sceneKey === 'welfareSignIn') {
            this.openModalData = CouponMapper(i);
            this.showSignModal = true;
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_sign_in_pop',
              contentId: 'platform_sign_in_pop',
              exposureTimes: 1,
              businessInfo: {},
            });
          }
          if (i.sceneKey === 'newcomerGift') {
            const tempList = [];
            if (i.showData) {
              i.showData.propList.forEach((x) => {
                tempList.push(CouponMapper(x));
              });
              this.openModalData = tempList;
              if (tempList.length > 0) {
                this.showOpenNewCustomer = true;
                if (env.isEasyBikeApp) {
                  UBT.moduleExpose({
                    pageId: 'platform_openedcard_page',
                    categoryId: 'platform',
                    moduleId: 'platform_gift_pop',
                    contentId: 'platform_gift_pop',
                    exposureTimes: 1,
                    businessInfo: {},
                  });
                }
              }
            }
          }
          if (i.sceneKey === 'renewSendCoupon') {
            try {
              getBenifitsInReopen({ token, systemCode: getSystemCode(), cityCode }).then((val) => {
                if (val && val.data) {
                  this.renewSendCouponData = val.data;
                  if (this.renewSendCouponData.couponMaps) {
                    this.showPriceReductionRenewal = true;
                  } else {
                    this.showPriceReductionRenewal = false;
                  }
                }
              });
              // eslint-disable-next-line no-empty
            } catch (e) {
            }
          }
          if (i.sceneKey === 'rideTrialPerception') {
            this.showGuideModal = true;
            this.openModalData = i.showData;
          }
          if (i.sceneKey === 'externalInterest') {
            this.showExternalInterest = true;
            this.openModalData = i;
          }
          if (i.sceneKey === 'winningPopup') {
            this.showWinningDialog = true;
            this.winningData = i.showData;
          }
          if (i.sceneKey === 'bottomLineReward') {
            this.showNoWinDialog = true;
            this.noWinData = i.showData;
          }
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('e', e);
      }
    },
    goQa() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_QA',
        categoryId: 'platform',
        businessInfo: {
          BusinessLine: this.appCode,
          membership_version: this.propVersion === PropVersionMap.NORMAL ? '1' : '2',
        },
      });
      Navigator.go(`https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env}/`}latest/index.html#/vip/super/components/qa?goodsGuid=${this.goodsGuid}`);
    },
    async checkShowQa() {
      const { token } = await getTokenAndKey();
      try {
        const res = await showQa({
          token,
          action: 'aries.vip.qa.get',
          goodsGuid: this.goodsGuid,
        });
        if (res.data) {
          this.showQa = true;
          this.appCode = res.data.appCode;
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_QA',
            contentId: 'platform_QA',
            exposureTimes: 1,
            businessInfo: {},
          });
        } else {
          this.showQa = false;
        }
      } catch (e) {
        this.showQa = false;
        // eslint-disable-next-line no-console
        console.log('e', e);
      }
    },
    async refreshAward(val) {
      this.getAwardList(val);
      this.getNoUse();
    },
    async getAwardList(val) {
      const { token } = await getTokenAndKey();
      try {
        const res = await getTaurusAward({
          token,
          channelId: env.platformCode,
          systemCode: getSystemCode(),
        });
        if (res.data) {
          this.showAwardList = res.data.showTaurus;
          this.rewardTaskGuidanceList = res.data.rewardTaskGuidanceList;
          if (this.rewardTaskGuidanceList && this.rewardTaskGuidanceList.length > 0) {
            const names = this.rewardTaskGuidanceList.map((obj) => obj.showName);
            const resultString = names.join(',');
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_zhuanjinbi',
              contentId: 'platform_zhuanjinbi',
              exposureTimes: 1,
              businessInfo: {
                businessType: resultString,
              },
            });
          }
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_chongzhi',
            contentId: 'platform_chongzhi',
            exposureTimes: 1,
            businessInfo: {},
          });
          this.awardList = res.data.infos || [];
          this.recordTotalReceiveBonusNum = res.data.recordTotalReceiveBonusNum;
          this.didSignToday = res.data.didSignToday || false;
          this.bountyCountToday = res.data.bountyCountToday;
          this.bountyCountYesterday = res.data.bountyCountYesterday;
          this.signRemainDays = res.data.remainDays;
          this.signShowStyle = res.data.signShowStyle;
          this.allTotalShow = res.data.allTotalShow;
          this.remainBountyCount = res.data.remainBountyCount;
          this.points = res.data.points;
          this.waitReceiveBonusNum = res.data.waitReceiveBonusNum;
          this.mobileCharge = res.data.mobileCharge;
          const vipRecordGuid = Storage.getItem('vip-record-guid');
          if (val) {
            let totalNum = 0;
            val.forEach((i) => {
              totalNum += i.offerWorth;
            });
            const vipTotalBounsNum = Storage.getItem('vip-total-bonus-num');
            await Storage.setItem('award-bouns-num', (vipTotalBounsNum + totalNum));
          } else if (!this.signShowStyle) {
            await Storage.setItem('vip-total-bonus-num', res.data.recordTotalReceiveBonusNum);
          } else {
            await Storage.setItem('vip-total-bonus-num', res.data.points);
          }
          const awardBonusNum = await Storage.getItem('award-bouns-num');
          if (vipRecordGuid === res.data.vipRecordGuid) {
            if (!this.signShowStyle) {
              if (!awardBonusNum) {
                this.recordTotalReceiveBonusNum = `${res.data.recordTotalReceiveBonusNum}`;
              } else if (awardBonusNum < res.data.recordTotalReceiveBonusNum) {
                this.recordTotalReceiveBonusNum = `${res.data.recordTotalReceiveBonusNum}`;
              } else {
                this.recordTotalReceiveBonusNum = awardBonusNum;
              }
            } else if (!awardBonusNum) {
              this.points = `${res.data.points}`;
            } else if (awardBonusNum < res.data.points) {
              this.points = `${res.data.points}`;
            } else {
              this.points = `${awardBonusNum}`;
            }
          } else {
            Storage.removeItem('award-bouns-num');
            Storage.setItem('vip-record-guid', res.data.vipRecordGuid);
            this.recordTotalReceiveBonusNum = `${res.data.recordTotalReceiveBonusNum}`;
            this.points = `${res.data.points}`;
          }
          this.vipRecordGuid = res.data.vipRecordGuid;
          this.getComponentsData();
        }
        this.getComponentsData();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    getComponentsData() {
      // 动态构建componentsData数组
      const componentsData = [];
      // 头部用户和会员信息
      componentsData.push({
        component: 'openMemberTop',
        props: {
          ride_trial_verison: this.ride_trial_verison,
          propVersion: this.propVersion,
          isNextCycleCharged: this.isNextCycleCharged,
          expirationDate: this.expirationDate,
          nextPeriodBenefitStartTime: this.nextPeriodBenefitStartTime,
          discountAmount: this.discountAmount,
          autoRenewalStatus: this.autoRenewalStatus,
          currentOrderOptType: this.currentOrderOptType,
          needDayTips: this.needDayTips,
          rideTrialUpgradeAB: this.rideTrialUpgradeAB,
          isLotteryNew: this.lotteryNewVersion,
          userInfo: this.userInfo,
          mobileOperatorCustomizeInfoDTO: this.mobileOperatorCustomizeInfoDTO,
        },
        condition: this.propVersion,
        // eslint-disable-next-line no-nested-ternary
        className: this.freeRightsVersion() ? '' : (this.tabCode === 'ladder' ? 'openMemberTop' : 'openMemberTopNoladder'),
      });
      componentsData.push({
        component: 'free-rights',
        props: {
          isOpen: true,
          moduleData: this.freeRightsData,
          currentOrderOptType: this.currentOrderOptType,
        },
        condition: this.freeRightsVersion(),
      });

      // 体验版
      if (this.ride_trial_verison) {
        componentsData.push({
          component: 'newCustomer',
          props: {
            newCustomerData: this.newCustomerData,
          },
          condition: this.newCustomerData && this.currentOrderOptType === 70,
          className: 'newCustomer',
        });
        if (this.currentOrderOptType !== 70) {
          componentsData.push({
            component: 'rideCard',
            props: {
              groups: this.groupsOne,
              couponGameAB: this.couponGameAB,
              isLotteryNew: this.lotteryNewVersion,
            },
            condition: this.getRide() && this.currentOrderOptType !== 70,
          });
        }
        if (this.trial_propList && Object.keys(this.trial_propList).length > 0) {
          componentsData.push({
            component: 'rideExperienceCard',
            condition: this.trial_propList && Object.keys(this.trial_propList).length > 0,
            props: {
              rideTrialUpgradeAB: this.rideTrialUpgradeAB,
            },
          });
        }
        if (this.showAwardList && this.allTotalShow === 'Y' && !this.lotteryNewVersion) {
          componentsData.push({
            component: 'rewardPrivilege',
            props: {
              recordTotalReceiveBonusNum: this.recordTotalReceiveBonusNum,
              awardList: this.awardList,
              rewardTaskGuidanceList: this.rewardTaskGuidanceList,
              signShowStyle: this.signShowStyle,
              points: this.opints,
            },
            condition: true,
            className: 'award-block',
          });
        }
        componentsData.push({
          component: 'NewLotteryNAward',
          props: {
            // 共用
            moduleData: { ...this.lotteryData },
            // 奖励金模块
            awardList: this.awardList,
            points: this.points,
            rewardTaskGuidanceList: this.rewardTaskGuidanceList,
            recordTotalReceiveBonusNum: this.recordTotalReceiveBonusNum,
            didSignToday: this.didSignToday,
            bountyCountToday: this.bountyCountToday,
            bountyCountYesterday: this.bountyCountYesterday,
            remainDays: this.signRemainDays,
            remainBountyCount: this.remainBountyCount,
            propVersion: this.propVersion,
            vipRecordGuid: this.vipRecordGuid,
            waitReceiveBonusNum: this.waitReceiveBonusNum,
            currentOrderOptType: this.currentOrderOptType,
            mobileCharge: this.mobileCharge,
            mobileChargeCoupon: this.mobileChargeCoupon,
          },
          condition: this.showLottery,
        });
        this.componentsData = componentsData;
      } else {
        if (this.showAwardList && this.allTotalShow === 'Y' && !this.lotteryNewVersion) {
          componentsData.push({
            component: 'rewardPrivilege',
            props: {
              recordTotalReceiveBonusNum: this.recordTotalReceiveBonusNum || this.opints,
              awardList: this.awardList || [],
              rewardTaskGuidanceList: this.rewardTaskGuidanceList,
              didSignToday: this.didSignToday,
              bountyCountToday: this.bountyCountToday,
              signShowStyle: this.signShowStyle,
              points: this.points,
            },
            condition: !this.freeRightsVersion(),
            className: 'award-block',
          });
        }
        if (!this.lotteryNewVersion && this.showAwardBlock && !this.freeRightsVersion()) {
          componentsData.push({
            component: 'awardBlockNew',
            props: {
              awardList: this.awardList,
              points: this.points,
              rewardTaskGuidanceList: this.rewardTaskGuidanceList,
              recordTotalReceiveBonusNum: this.recordTotalReceiveBonusNum,
              didSignToday: this.didSignToday,
              bountyCountToday: this.bountyCountToday,
              bountyCountYesterday: this.bountyCountYesterday,
              remainDays: this.signRemainDays,
              remainBountyCount: this.remainBountyCount,
              propVersion: this.propVersion,
              vipRecordGuid: this.vipRecordGuid,
              waitReceiveBonusNum: this.waitReceiveBonusNum,
              mobileCharge: this.mobileCharge,
              mobileChargeCoupon: this.mobileChargeCoupon,
            },
            condition: this.showAwardList,
            className: 'award-no-margin',
          });
        }
        // 所有随心骑版本特有组件
        if (this.getRide()) {
          // 进入联名会员
          if (this.isShowUnionRights) {
            componentsData.push({
              component: 'RideMonthNUnionVip',
              props: {
                groups: this.groupsOne,
                propVersion: this.propVersion,
                isLotteryNew: this.lotteryNewVersion,
                unionData: this.unionData,
              },
              condition: this.getRide(),
            });
          } else {
            componentsData.push({
              component: 'rideMouth',
              props: {
                groups: this.groupsOne,
                propVersion: this.propVersion,
                isLotteryNew: this.lotteryNewVersion,
              },
              condition: this.getRide() && !this.freeRightsVersion(),
              className: 'ride-mouth',
            });
          }
          componentsData.push({
            component: 'rideCard',
            props: {
              groups: this.groupsOther[0],
              couponGameAB: this.couponGameAB,
              vipData: this.vipData,
              isLotteryNew: this.lotteryNewVersion,
            },
            condition: this.getRide(),
          });
          componentsData.push({
            component: 'awardBlockNew',
            props: {
              awardList: this.awardList,
              points: this.points,
              rewardTaskGuidanceList: this.rewardTaskGuidanceList,
              recordTotalReceiveBonusNum: this.recordTotalReceiveBonusNum,
              didSignToday: this.didSignToday,
              bountyCountToday: this.bountyCountToday,
              bountyCountYesterday: this.bountyCountYesterday,
              remainDays: this.signRemainDays,
              remainBountyCount: this.remainBountyCount,
              propVersion: this.propVersion,
              vipRecordGuid: this.vipRecordGuid,
              waitReceiveBonusNum: this.waitReceiveBonusNum,
              mobileCharge: this.mobileCharge,
              mobileChargeCoupon: this.mobileChargeCoupon,
            },
            condition: this.freeRightsVersion(),
            className: '',
          });
        }
        // 随心骑版本或阶梯权益版本都可以展示的抽奖模块
        if (this.getRide() || this.getLadder()) {
          if (this.lotteryNewVersion) {
            // 实验组
            componentsData.push({
              component: 'NewLotteryNAward',
              props: {
                // 共用
                moduleData: { ...this.lotteryData },
                // 奖励金模块
                awardList: this.awardList,
                points: this.points,
                rewardTaskGuidanceList: this.rewardTaskGuidanceList,
                recordTotalReceiveBonusNum: this.recordTotalReceiveBonusNum,
                didSignToday: this.didSignToday,
                bountyCountToday: this.bountyCountToday,
                bountyCountYesterday: this.bountyCountYesterday,
                remainDays: this.signRemainDays,
                remainBountyCount: this.remainBountyCount,
                propVersion: this.propVersion,
                vipRecordGuid: this.vipRecordGuid,
                waitReceiveBonusNum: this.waitReceiveBonusNum,
                currentOrderOptType: this.currentOrderOptType,
                mobileCharge: this.mobileCharge,
                mobileChargeCoupon: this.mobileChargeCoupon,
              },
              condition: this.showLottery && !this.freeRightsVersion(),
            });
          } else {
            // 对照组
            componentsData.push({
              component: 'Lottery',
              props: {
                moduleData: { ...this.lotteryData },
                currentOrderOptType: this.currentOrderOptType,
              },
              condition: this.showLottery,
            });
          }
        }
        if (this.plusGiftList.length > 0 && this.env.isEasyBikeApp) {
          componentsData.push({
            component: 'plusGift',
            props: {
              cardInfo: this.plusGiftList,
            },
            condition: this.plusGiftList.length > 0 && this.env.isEasyBikeApp,
            className: 'plus-gift-top',
          });
        }
        if (this.giftData && this.env.isEasyBikeApp && this.giftData.length > 0) {
          componentsData.push({
            component: 'memberOpenGift',
            props: {
              giftData: this.giftData,
              propVersion: this.propVersion,
            },
            condition: this.giftData && this.env.isEasyBikeApp && this.giftData.length > 0,
          });
        }
        this.componentsData = componentsData;
      }
    },
    closeScroll() {
      getNoScroll(false);
    },
    goCS() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_user_service',
        categoryId: 'platform',
        businessInfo: {},
      });
      Navigator.go(`https://m.hellobike.com/AppHelloBikeReactH5/${config.envUrlMixin}latest/pr_index_entrance.html#/entrance?sourcePage=MEMBER_HOME_PAGE`);
    },
    firstStatus(item) {
      if (item.status === 9 || item.status === 10) {
        this.showChangeModal = true;
        this.openChangeType = 3;
        this.changeValue = item;
        return;
      }
      if (item.status === this.status.locked) return;

      if (this.propVersion === PropVersionMap.LADDER) {
        if (item.status === this.status.use) {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_coupon_use',
            categoryId: 'platform',
            businessInfo: {
              BusinessLine: item.propBusinessLine,
            },
          });
        } else if (item.status === this.status.receive) {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_coupon_get',
            categoryId: 'platform',
            businessInfo: {
              BusinessLine: item.propBusinessLine,
            },
          });
        }
      }

      if (env.isEasyBikeApp) {
        if (item.status === this.status.use) {
          this.useCoupon(item);
        } else if (item.status === this.status.receive) {
          if (item.closeRedPacket) {
            this.receiveCoupon(item);
          } else {
            this.openReceiveModal(item);
          }
        } else if (item.status === this.status.wait) {
          this.waitCoupon(item);
        }
      } else if (item.status === this.status.use) {
        if (this.propVersion !== PropVersionMap.RIDE_UNIVERSAL) {
          if (env.isWeixin || env.isWechatMini) {
            this.goUrl(this.config.wechatLink, true);
          } else {
            this.goUrl(this.config.deepLink, true);
          }
        } else {
          Navigator.go(item.propUrl || (item.detail && item.detail.propUrl) || '');
        }
      } else if (item.status === this.status.receive) {
        this.openReceiveModal(item);
      } else if (item.status === this.status.wait) {
        this.waitCoupon(item);
      }
    },
    goUrl(url = this.config.deepLink, download = false) {
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      window.location.href = url;
    },
    goOther(item) {
      if (item.bonusEntity && (item.bonusEntity.payedImageAliUrl || item.bonusEntity.payedImageUrl)) {
        if (env.isAlipayBrowser || env.isAliMP) {
          Native.callNative({
            method: 'goOperationUrlV2',
            params: item.bonusEntity.payedImageAliUrl,
          });
        } else {
          Navigator.go(item.bonusEntity.payedImageUrl);
        }
      }
    },
    openCommonBonus(value) {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_Quick_navigation_detail2',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$refs.onepageup.open(value);
      getNoScroll(true);
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_Quick_navigation_detail2',
        contentId: 'platform_Quick_navigation_detail2',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    getName(value) {
      if (!env.isEasyBikeApp) {
        if (value === '去使用') {
          return '去APP使用';
        }
        return value;
      }
      return value;
    },
    getBigMoney(value) {
      return parseInt(value, 10);
    },
    getSmallMoney(value) {
      if (!value || value % 1 === 0) {
        return '';
      }
      return `${value.toString().substring(value.toString().indexOf('.'), value.length)}`;
    },
    judgeBtn() {
      const { available, handmax } = RENEWAL_STATUS;
      if ([available, handmax].includes(this.autoRenewalStatus)) {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_lijixufei',
          contentId: 'platform_lijixufei',
          exposureTimes: 1,
          businessInfo: {},
        });
        return true;
      }
      return false;
    },

    renewBtn() {
      if (this.autoRenewalStatus === RENEWAL_STATUS.signed) {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_guanlixufei',
          contentId: 'platform_guanlixufei',
          exposureTimes: 1,
          businessInfo: {},
        });
        return true;
      }
      return false;
    },
    async receiveCoupon(cp) {
      const coupon = this.toReceiveCoupon || cp;
      if (!coupon) {
        return;
      }
      UBT.clickButton({
        pageId: 'platform_PaidMemberDetail',
        buttonName: 'platform_receive',
        categoryId: 'platform',
        businessInfo: {
          BatchId: (coupon.detail && coupon.detail.propCode) || coupon.propCode || '',
          adsource: getSource(),
        },
      });
      const { token } = await getTokenAndKey();
      const { userVipPropGuid, propCode, propName } = coupon.detail || coupon;
      receiveVipCoupon({
        token, userVipPropGuid, propCode, systemCode: getSystemCode(), propName,
      })
        .then((res) => {
          if (res.data) {
            if (res.data.waitingTime) {
              Loading.show();
              this.loadingTimer = setTimeout(async () => {
                await Loading.close();
                Toast.show('领取成功');
                this.showChangeModal = false;
              }, res.data.waitingTime);
            } else {
              Toast.show('领取成功');
              this.showChangeModal = false;
            }
          } else {
            Toast.show('网络开小差');
          }
        })
        .catch((e) => {
          Toast.showError(e);
        })
        .then(() => {
          // this.getData();
          this.refreshData();
        });
    },
    async getWaitPayOrder() {
      const { token } = await getTokenAndKey();
      try {
        const res = await getWaitPayOrder({
          token,
          action: 'aries.vip.order.getWaitPayOrder',
        });
        if (res.data) {
          this.noPayData = res.data;
          this.showNopay = true;
        } else {
          this.showNopay = false;
        }
      } catch (e) {
        Toast.showError(e);
      }
    },
    refreshNopay() {
      this.showNopay = false;
      // this.getData();
      this.refreshData();
    },
    async cancel() {
      const { token } = await getTokenAndKey();
      try {
        await closeVipGoods({
          token,
          action: 'aries.vip.order.closeVipGoods',
          orderNo: this.noPayData.orderNo,
        });
        Toast.show('取消成功');
        // this.getData();
        this.refreshData();
      } catch (e) {
        Toast.showError(e);
      }
    },
    closeNew() {
      this.showNopay = false;
      this.showRenwalRide = false;
      this.showRenwal = false;
      getNoScroll(false);
    },
    renewaWayRide() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_lijixufei',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (this.autoRenewalStatus === RENEWAL_STATUS.handmax) {
        Toast.show('当前会员仅支持连续续费12个月');
        return;
      }
      if (this.ride_trial_verison) {
        this.showBuyMemberModal = true;
      } else {
        this.showRenwalRide = true;
      }
      getNoScroll(true);
      UBT.moduleExpose({
        pageId: 'platform_savemoneycard_page',
        categoryId: 'platform',
        moduleId: 'platform_type_choose_detail',
        contentId: 'platform_type_choose_detail',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    refreshData() {
      this.$emit('refresh');
    },
    getThirdData() {
      if (!this.vipData) {
        return;
      }
      const {
        groupList = [], usablePropAmount, upgradeNoticeDate, goodsGuid,
        propVersion,
        ladderDetailMap = {},
        ladderGroupList = [],
        couponGameAB,
        vipRecordGuid,
        moduleInfos,
        rideTrialUpgradeAB,
        mobileOperatorCustomizeInfoDTO = {},
      } = this.vipData;
      this.rideTrialUpgradeAB = rideTrialUpgradeAB;
      this.upgradeNoticeDate = upgradeNoticeDate;
      this.usablePropAmount = usablePropAmount;
      this.goodsGuid = goodsGuid;
      this.commonBonus = this.vipData.commonBonus;
      this.propVersion = propVersion;
      this.ladderDetailMap = ladderDetailMap;
      this.couponGameAB = couponGameAB;
      this.mobileOperatorCustomizeInfoDTO = mobileOperatorCustomizeInfoDTO || {};
      if (moduleInfos && Array.isArray(moduleInfos)) {
        this.lotteryData = { ...(moduleInfos.find((i) => i.moduleCode === 'dayLottery') || {}).moduleData };// 日日抽
        this.giftData = moduleInfos.filter((i) => i.moduleCode === 'openCeremony'); // 开卡礼
        this.freeRightsData = { ...(moduleInfos.find((i) => i.moduleCode === 'freeBillPrivilege') || {}).moduleData && { ...(moduleInfos.find((i) => i.moduleCode === 'freeBillPrivilege') || {}).moduleData.freeRights } };// 免单特权
        this.externalInfo = { ...(moduleInfos.find((i) => i.moduleCode === 'externalProperty') || {}).moduleData };// 外部权益数据
        const tempNewCustomerData = { ...(moduleInfos.find((i) => i.moduleCode === 'homePageActivity') || {}) };
        if (tempNewCustomerData) {
          if (tempNewCustomerData.moduleData && tempNewCustomerData.moduleData.propList) {
            const { propList } = tempNewCustomerData.moduleData;
            tempNewCustomerData.moduleData.propList = propList.map(CouponMapper);
          }
          this.newCustomerData = tempNewCustomerData;
        } else {
          this.newCustomerData = null;
        }
      } else {
        this.newCustomerData = null;
      }

      if (this.couponGameAB === 'Y') {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_exchange_coupons',
          contentId: 'platform_exchange_coupons',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
      if (this.couponGameAB === 'N') {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_Change_Record',
          contentId: 'platform_Change_Record',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
      this.vipRecordGuidData = vipRecordGuid;
      // if (pageShowStyle) {
      //   this.rideCardShowStyle = pageShowStyle.rideCardShowStyle;
      // }
      // propTimes
      if (ladderGroupList.length) {
        this.ladderPropGroupList = ladderGroupList
          .map((ladderItem) => ({
            ...ladderItem,
            propList: ladderItem.propList.map(CouponMapper),
          }));
      }
      if (groupList.length) {
        this.groupList = [{ ...groupList[0], propList: groupList[0].propList.map(CouponMapper) }];
      }
      this.groups = groupList.map((g) => {
        const {
          groupName: title,
          groupDesc: subtitle,
          groupAmount: amount,
          isExclusive,
          propList = [],
          todayExpirePropNum,
          usablePropNum,
          groupIndex,
          groupCode,
          propIcon,
          goodsPropDesc,
          afterVipExtendProperty,
          afterVipRecycleProperty,
          afterVipReplacementProperty,
        } = g;
        return {
          title,
          amount,
          subtitle,
          isExclusive,
          propList,
          todayExpirePropNum,
          usablePropNum,
          groupIndex,
          groupCode,
          coupons: propList.map((item) => CouponMapper(item, propVersion)),
          type: 2,
          propIcon,
          goodsPropDesc,
          afterVipExtendProperty,
          afterVipRecycleProperty,
          afterVipReplacementProperty,
        };
      });
      [this.groupsOne, ...this.groupsOther] = this.groups;

      const curGroupList = (this.propVersion === PropVersionMap.RIDE_TRIAL && this.currentOrderOptType !== 70) || this.getLadder()
        ? this.groupsOne : this.groupsOther[0];

      const telephoneBusinessKey = TELEPHONE_BUSINESS[config.env] || TELEPHONE_BUSINESS.pro;

      this.mobileChargeCoupon = (curGroupList && curGroupList.coupons.length && curGroupList.coupons.find((i) => i.propBusinessLine === telephoneBusinessKey)) || {};

      this.groupsOther.forEach((i, index) => {
        if (index < 2) {
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: `platform_openedcard_model${index + 1}`,
            contentId: `platform_openedcard_model${index + 1}`,
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        if (i.groupCode === 'NEWCOMER_GIFT') {
          this.plusGiftList = i.coupons;
          if (this.plusGiftList.length > 0 && env.isEasyBikeApp) {
            let biz = '';
            this.plusGiftList.forEach((x) => {
              biz += `${x.goodsPropDesc},`;
            });
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_gift',
              contentId: 'platform_gift',
              exposureTimes: 1,
              businessInfo: {
                businessType: biz,
              },
            });
          }
        }
      });
      this.haveData = true;
      this.otherList = (this.commonBonus || []).filter((i) => i.bonusEntity.payedImage !== '' && i.bonusEntity.payedImage);
      this.otherList.forEach((i, index) => {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: `platform_model${index + 1 + this.groupsOther.length}`,
          contentId: `platform_model${index + 1 + this.groupsOther.length}`,
          exposureTimes: 1,
          businessInfo: {},
        });
      });
      this.businessCoupon = tryCatch(() => this.groups.filter((v) => v.groupCode !== UNDER_ONE));
      if (this.autoRenewalStatus === RENEWAL_STATUS.available
        || this.autoRenewalStatus === RENEWAL_STATUS.handmax) {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_manually_renew',
          contentId: 'platform_manually_renew',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
      this.isShowUnionRights = !!this.vipData.additionalProperty;
      if (this.vipData.additionalProperty) {
        this.unionData = this.vipData.additionalProperty.additionalPropertyList[0];
      }
      // this.getComponentsData();
    },
    async getData() {
      const isLogin = await Native.isLogin();
      if (!isLogin) {
        return;
      }
      const { token } = await getTokenAndLocation();
      this.token = token;

      await getVipStatus({
        token,
        systemCode: getSystemCode(),
        checkRenewStatus: true,
        currentPage: 'OPENED_VIP_DETAIL_PAGE',
      })
        .then(async (res) => {
          if (res && res.data) {
            // 用户会员信息
            const {
              expirationDate,
              openVip,
              totalDiscountAmount: discountAmount,
              remainDays,
              autoRenewalStatus,
              renewalPrice,
              vipStartTime,
              currentOrderOptType,
              isNextCycleCharged,
              nextPeriodBenefitStartTime,
              needDayTips,
            } = res.data || {};
            /** 会员信息 */
            this.userInfo = res.data;

            if (openVip) {
              Object.assign(this, {
                expirationDate,
                openVip,
                discountAmount,
                remainDays,
                autoRenewalStatus,
                renewalPrice,
                vipStartTime,
                currentOrderOptType,
                isNextCycleCharged,
                nextPeriodBenefitStartTime,
                needDayTips,
              });
            }
            if (autoRenewalStatus === RENEWAL_STATUS.SIGNED) {
              UBT.moduleExpose({
                pageId: 'platform_openedcard_page',
                categoryId: 'platform',
                moduleId: 'platform_renew_inform',
                contentId: 'platform_renew_inform',
                exposureTimes: 1,
                businessInfo: {},
              });
            }
          }
          return res.data;
        }).then((res) => {
          if (res) {
            this.getRidetrial(res.propVersion, res.currentOrderOptType);
          }
        })
        .catch(() => null);

      this.getThirdData();
      this.checkShowQa();
      await this.getComponentsData();
      this.getNoUse();
    },
    async getRidetrial(propVersion, currentOrderOptType) {
      const { token, cityCode } = await getTokenAndLocation();
      // 端外搭售21 直充50
      if (propVersion === PropVersionMap.RIDE_TRIAL) {
        if (currentOrderOptType === 21 || currentOrderOptType === 50 || currentOrderOptType === 70 || currentOrderOptType === 60) {
          await getBenifitsInReopen({ token, systemCode: getSystemCode(), cityCode }).then((val) => {
            if (val && val.data) {
              this.trial_info = val.data;
              if (this.trial_info.groupList && Array.isArray(this.trial_info.groupList) && this.trial_info.groupList.length > 1) {
                // eslint-disable-next-line prefer-destructuring
                this.trial_propList = this.trial_info.groupList[1];
                this.trial_propList.propertyDetailDTOS = this.trial_propList.propList;
                this.trial_propList.signInfoDTO = this.trial_info.signInfoDTO;
                this.trial_propList.unOpenShowCanBuy = true;
                this.trial_propList.current = this.trial_info.price;
                this.trial_propList.original = this.trial_info.markedPrice;
                this.trial_propList.goodsGuid = this.trial_info.goodsGuid;
              }
            }
          });
        }
        if ((currentOrderOptType === 21 || currentOrderOptType === 50 || currentOrderOptType === 70)) {
          this.ride_trial_verison = true;
        } else {
          this.ride_trial_verison = false;
        }
        if (this.haveData && !this.isNextCycleCharged) {
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_VIPnewpay',
            contentId: 'platform_VIPnewpay',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      } else {
        this.ride_trial_verison = false;
      }
      this.propVersion = propVersion;
      await this.getComponentsData();
    },
    async bayCardHandler(val, num, price, goodsGuid, extra = {}) { // 续费开通时接收goodsGuid
      if (this.payingFlag) {
        Toast.show('正在支付中，请稍候');
        return;
      }

      const { token, cityCode, adCode } = await getTokenAndLocation();
      if (!token) {
        Toast.show('请先登录');
      }

      let orderOptType = num || 0;
      // 联名会员续费
      if (extra.additionalGuid) {
        // 连续包月
        if (num === 30) {
          orderOptType = OrderOptType.JOINT_MEMBER_CIRCLE;
        } else if (num === 20) {
          orderOptType = OrderOptType.JOINT_MEMBER_REBUY;
        }
      }
      const toPost = {
        cityCode,
        adCode,
        token,
        ...{
          price,
          goodsGuid,
        },
        systemCode: getSystemCode(),
        orderExtInfo: JSON.stringify({
          rideTrialUpgradeAB: this.rideTrialUpgradeAB,
        }),
        orderOptType, // 0：用户正常下单；10:手动续费下单； 30:连续包月下单
        additionalGuid: extra.additionalGuid || '',
      };
      if ((num === 30 || num === 60) && !toPost.price) {
        CardService.signWithoutPasswordContract().then(() => this.buyGoods(num, toPost, val));
      } else {
        this.buyGoods(num, toPost, val);
      }
      this.transType = num;
    },
    buyGoods(num, toPost, val) {
      if (this.payingFlag) {
        Toast.show('正在支付中，请稍候');
        return;
      }
      this.payingFlag = true;
      buyVipGoods(toPost)
        .then(async (v) => {
          const { token } = await getTokenAndLocation();
          if (v && v.data) {
            const {
              loopIntervalSecond,
              orderNo,
              loopTotalSecond,
              showPopUpWindowType,
            } = v.data;
            if (env.isWechatMini) {
              if (num === 30) {
                // 连续包月
                if (showPopUpWindowType === 1 && !val) {
                  await this.getWaitPayOrder();
                  this.payingFlag = false;
                  return;
                }
                await CardService.evokePageAndSign(v.data, this.planId);
                return;
              }
              window.location.replace(ParamsUtil.addParams(window.location.href, {
                loopIntervalSecond,
                orderNo,
                loopTotalSecond,
              }));
            }
            if (showPopUpWindowType === 1 && !val) {
              await this.getWaitPayOrder();
              this.payingFlag = false;
            } else if (toPost.price) {
              if (num !== ORDER_TYPE.CONTINUOUS_MONTHLY && num !== ORDER_TYPE.UNION_CONTINUOUS_MONTH && this.propVersion !== PropVersionMap.RIDE_ONE_CENT) {
                if (toPost.price) {
                  setTimeout(() => {
                    this.payingFlag = false;// 由于buy方法未推进promise状态 拉起比较迅速 所以直接置为没正在支付
                  }, 1000);
                  await CardService.buyMember(v.data)
                    .then(() => {
                      this.searchStatus(
                        {
                          token,
                          orderNo,
                          loopIntervalSecond,
                          loopTotalSecond,
                        },
                        num,
                      );
                    })
                    .catch((e) => {
                      if (e) {
                        Toast.showError(e);
                      }
                    });
                } else {
                  this.searchStatus(
                    {
                      token,
                      orderNo,
                      loopIntervalSecond,
                      loopTotalSecond,
                    },
                    num,
                  );
                }
              } else if (!env.isEasyBikeApp && !env.isAlipayBrowser && !env.isAliMP) {
                const queryRedirectUrl = `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/index.html#/vip/v2/transfer`;
                const baseQuery = `redirectUrl=${encodeURIComponent(queryRedirectUrl)}&h5Login=1`;
                const schemeQuery = config.env === 'fat' ? baseQuery : `codeEnv=${config.env}&${baseQuery}`;
                const scheme = `alipays://platformapi/startapp?appId=2017050407110255&page=/pages/index/index&query=${encodeURIComponent(schemeQuery)}`;
                window.location.href = scheme;
              } else {
                let data = { ...v.data };
                if (this.propVersion === PropVersionMap.RIDE_ONE_CENT) {
                  // 一分骑走抖音签约,抖音签约参数
                  const isContinuous = [ORDER_TYPE.CONTINUOUS_MONTHLY, ORDER_TYPE.UNION_CONTINUOUS_MONTH].includes(num);
                  const channel = isContinuous ? '2309' : '2304';
                  const extension = isContinuous
                    ? {
                      planId: '', // 无需传planId，就会有兜底planId
                      signMustPay: true,
                      attachSceneType: 'RIDE',
                    }
                    : {
                      signMustPay: true,
                    };
                  const { productTagForDySign = '', bizScene = '' } = this.payActivityInfo || {};
                  data = {
                    ...v.data,
                    channelOperationInfoExt: {
                      productTagForDySign,
                      biz_scene: bizScene,
                    },
                    channel,
                    extension,
                  };
                }
                await CardService.buyContinueMember(data).then(() => {
                  this.searchStatus({
                    token,
                    orderNo,
                    loopIntervalSecond,
                    loopTotalSecond,
                  }, num);
                }).catch((e) => {
                  if (e) {
                    Toast.showError(e);
                  }
                });
              }
            } else {
              this.searchStatus(
                {
                  token,
                  orderNo,
                  loopIntervalSecond,
                  loopTotalSecond,
                },
                num,
              );
            }
          }
        })
        .catch((e) => {
          Toast.showError(e);
        })
        .finally(() => {
          this.payingFlag = false;
        });
    },
    // 轮询付费会员状态
    async searchStatus({
      token, orderNo, loopIntervalSecond = 1, loopTotalSecond = 5,
    }, type) {
      // loopIntervalSecond 轮询间隔时间
      // loopTotalSecond 轮询总时间
      // 重置计数器
      this.curloopIntervalSecond = 0;

      const poll = async () => {
        if (this.curloopIntervalSecond >= loopTotalSecond) {
          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = null;
          }
          return;
        }

        try {
          const { data, msg } = await tryTakeOrderStatus({
            token,
            orderNo,
            systemCode: getSystemCode(),
          });


          if (data) {
            const { status, isUpgrade } = data;

            // 订单交易中，继续轮询
            if (status === ORDER_STATUS.padding) {
              this.curloopIntervalSecond += loopIntervalSecond;
              this.orderTimer = setTimeout(poll, loopIntervalSecond * 1000);// 更新timer
              return;
            }

            // 清除定时器
            if (this.orderTimer) {
              clearTimeout(this.orderTimer);
              this.orderTimer = null;
            }

            UBT.clickButton({
              pageId: 'platform_PurchasePage',
              buttonName: 'platform_ToPurchase',
              categoryId: 'platform',
              businessInfo: {
                adsource: getSource(),
                TransactionResults: (() => {
                  if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
                    return 0;
                  }
                  if (status === ORDER_STATUS.success) {
                    return 1;
                  }
                  return '';
                })(),
              },
            });

            // 订单成功
            if (status === ORDER_STATUS.success) {
              this.showBuyMemberModal = false;
              if (type === 30) {
                this.mainTipTitle = '会员连续包月开通成功！';
                this.subTipTitle = `将在${data.sendAfterDays > 0 ? data.sendAfterDays : '明'}天后（当前会员到期后），发放本次续费会员的权益`;
                if (this.$refs.tipModal) {
                  this.showRenwal = false;
                  this.showRenwalRide = false;
                  getNoScroll(false);
                  this.$refs.tipModal.open();
                  // this.getData();
                  this.refreshData();
                  this.getNoUse();
                }
              } else if (!isUpgrade) {
                this.mainTipTitle = '恭喜你，续费成功！';
                this.subTipTitle = `将在${data.sendAfterDays > 0 ? data.sendAfterDays : '明'}天后（当前会员到期后），发放本次续费会员的权益`;
                if (this.$refs.tipModal) {
                  this.showRenwal = false;
                  this.showRenwalRide = false;
                  getNoScroll(false);
                  this.$refs.tipModal.open();
                  // this.getData();
                  this.refreshData();
                  this.getNoUse();
                }
              } else {
                this.mainTipTitle = '恭喜你，升级成功!';
                this.subTipTitle = '体验会员已升级为正式会员，权益已刷新请注意查看';
                if (this.$refs.tipModal) {
                  this.showRenwal = false;
                  this.showRenwalRide = false;
                  getNoScroll(false);
                  this.$refs.tipModal.open();
                  this.getData();
                  this.getNoUse();
                }
              }
            }
            // 订单失败
            if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
              Toast.show('正在支付中，请稍候查看');
              this.$router.go(-1);
            }
          } else {
            // API 调用失败，停止轮询
            if (this.orderTimer) {
              clearTimeout(this.orderTimer);
              this.orderTimer = null;
            }
            Toast.show(msg);
          }
        } catch (error) {
          // 处理异常，停止轮询
          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = null;
          }
          Toast.show('查询订单状态失败');
        }
      };
      // 开始轮询
      this.orderTimer = setTimeout(poll, loopIntervalSecond * 1000);
    },
    openReceiveModal(item) {
      if ([PropVersionMap.LADDER,
        PropVersionMap.RIDE,
        PropVersionMap.LADDER_BLEND,
        PropVersionMap.LADDER_BLEND_TWO,
        PropVersionMap.RIDE_STEADY_VERSION,
        PropVersionMap.RIDE_RADICAL_VERSION,
      ].includes(this.propVersion)) {
        this.ladderReceiveCoupon = null;
        this.ladderReceiveCoupon = item;
        this.openLadderCoupon(item);
      } else {
        this.toReceiveCoupon = item;
        this.receiveCoupon(item);
      }
    },
    useCoupon(coupon) {
      if (coupon && coupon.detail && coupon.detail.propUrl) {
        if (this.propVersion !== PropVersionMap.LADDER) {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_openedcard_use_button',
            categoryId: 'platform',
            businessInfo: {
              adsource: getSource(),
            },
          });
        }
        this.willGuide = false;
        const url = ([PropVersionMap.LADDER,
          PropVersionMap.RIDE].includes(this.propVersion)) ? coupon.propUrl : coupon.detail.propUrl;
        Navigator.go(url);
      }
    },
    waitCoupon(coupon) {
      if ((coupon && coupon.detail && coupon.detail.receiveStartTime) || coupon.receiveStartTime) {
        // 当前时间
        const startTime = +new Date();
        // 领取开始时间
        const endTime = ([PropVersionMap.LADDER,
          PropVersionMap.RIDE].includes(this.propVersion)) ? coupon.receiveStartTime : coupon.detail.receiveStartTime;
        // 相差时间
        const diff = endTime - startTime;
        if (diff > 0) {
          const day = Math.ceil(diff / (24 * 60 * 60 * 1000));
          Toast.show(`${day}天后可领取此立减券`);
        } else if ([PropVersionMap.LADDER,
          PropVersionMap.RIDE,
          PropVersionMap.LADDER_BLEND,
          PropVersionMap.LADDER_BLEND_TWO].includes(this.propVersion)) {
          this.openLadderCoupon(coupon);
        } else { this.receiveCoupon(coupon); }
      }
    },
    rule() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_opencard_rule',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      window.onpageshow = null;
      window.addEventListener('pageshow', () => {
        window.location.reload();
      });
      Navigator.go('https://m.hellobike.com/mf/spa/u_jsawic/latest/MA2112242694445671692369920.html?activityCode=MA2112242694445671692369920', { isRuleLink: true });
    },
    handleBack() {
      this.goBack();
    },
    goBack() {
      Native.closeWebView();
    },
    clickMenu(index) {
      if (index === 0) {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_newrules2',
          categoryId: 'platform',
          businessInfo: {
            adsource: getSource(),
          },
        });
        Navigator.go('https://m.hellobike.com/mf/spa/u_jsawic/latest/MA2112242694445671692369920.html?activityCode=MA2112242694445671692369920', { isRuleLink: true });
      } else if (index === 1) {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_buycardrecord',
          categoryId: 'platform',
          businessInfo: {
            adsource: getSource(),
          },
        });
        this.$router.push('/vip/history');
      } else {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_user_service',
          categoryId: 'platform',
          businessInfo: {},
        });
        Navigator.go(`https://m.hellobike.com/AppHelloBikeReactH5/${config.envUrlMixin}latest/pr_index_entrance.html#/entrance?sourcePage=MEMBER_HOME_PAGE`);
      }
    },
    clickRecord() {
      this.$router.push('/vip/history');
    },
    goRule() {
      Navigator.go('https://m.hellobike.com/mf/spa/u_jsawic/latest/MA2112242694445671692369920.html?activityCode=MA2112242694445671692369920', { isRuleLink: true });
    },
    async isShowFeedbackRequest() {
      const { token } = await getTokenAndKey();
      isShowFeedback({ token })
        .then((res) => {
          if (res.data) {
            const { showFeedback = false } = res.data;
            this.isShowFeedbackEntry = showFeedback;
            if (showFeedback) {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_YIP_NPS',
                contentId: 'platform_YIP_NPS',
                exposureTimes: 1,
                businessInfo: {},
              });
            }
          }
        })
        .catch(() => ({}));
    },
    openFeedbackPopup() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_YIP_NPS',
        categoryId: 'platform',
        businessInfo: {},
      });
      getNoScroll(true);
      this.showFeedback = true;
    },
    async feedbackSubmit(point, info) {
      const { token } = await getTokenAndKey();
      await submitFeedback({
        token,
        point,
        info,
        systemCode: getSystemCode(),
        scene: 'propFeedBack',
      })
        .then((res) => {
          // 由于无res和code=103时都会走then，所以仅code=0 case为成功 关闭popup。
          if (res) {
            if (res.code === 0) {
              this.showFeedback = false;
              this.closeScroll();
              Toast.show('提交成功，感谢反馈');
            } else {
              Toast.showError(res.msg);
            }
          }
        })
        .catch((e) => Toast.showError(e));
      // this.isShowFeedbackRequest();
    },
    async openLadderCoupon(cp) {
      const coupon = this.ladderReceiveCoupon || cp;
      if (!coupon) {
        return;
      }
      UBT.clickButton({
        pageId: 'platform_PaidMemberDetail',
        buttonName: 'platform_receive',
        categoryId: 'platform',
        businessInfo: {
          BatchId: coupon.propCode || '',
          adsource: getSource(),
        },
      });
      const { token } = await getTokenAndKey();
      const { userVipPropGuid, propCode, propName } = coupon;
      receiveVipCoupon({
        token, userVipPropGuid, propCode, systemCode: getSystemCode(), propName,
      })
        .then((res) => {
          if (res.data.waitingTime) {
            Loading.show();
            this.loadingTimer = setTimeout(async () => {
              await Loading.close();
            }, res.data.waitingTime);
          }
          const { showLadderCoupon } = coupon;
          // showLadderCoupon 为false, 不展示弹窗
          if (showLadderCoupon === false) {
            return;
          }
          this.bigCouponInfo = CouponMapper(res.data);
          this.showLadderCoupon = true;
          this.showChangeModal = false;
        })
        .catch((e) => {
          Toast.showError(e);
        })
        .then(() => {
          // this.getData();
          this.refreshData();
        });
    },
    goToModalUse(couponInfo) {
      if (couponInfo.sceneKey === 'remindReceiveProp') {
        this.receiveCoupon(couponInfo);
      } else if (env.isEasyBikeApp) {
        this.useCoupon(couponInfo);
      } else {
        this.goUrl(this.config.deepLink, true);
      }
    },
    goToLadderUse(couponInfo) {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_coupon_pop',
        categoryId: 'platform',
        businessInfo: {
          BusinessLine: couponInfo.propBusinessLine,
        },
      });
      // this.getData();
      this.refreshData();
      if (couponInfo.status === this.status.use) {
        if (env.isEasyBikeApp) {
          this.useCoupon(couponInfo);
        } else {
          this.goUrl(this.config.deepLink, true);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
/* 下架通知公告栏容器 */
.down-version-banner-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.1rem;
}

/* 下架通知弹窗容器 */
.down-version-popup-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.free-quark-nps-base {
  height: 1.21rem;
  margin: 0 0.08rem;
  display: block;

  --base-title-font-family: pingfangsc-regular, pingfang sc, sans-serif;
  --base-title-font-size: 14px;
  --base-title-font-weight: 600;
  --base-title-line-height: 22px;
  --base-title-color: #242729;
  --base-score-background: #f8a828;
  --base-score-active-background: #fb500a;
  --container-padding-x: 16px;
  --container-padding-y: 16px;
  --base-score-height: 38px;
  --popup-bg: url(https://m.hellobike.com/resource/helloyun/22871/K24eO_bg.png) left top / 100% auto no-repeat, #fff;
  --score-active-color: #fff;
  --score-active-background: #fb500a;
  --tag-height: 28px;
  --tag-active-background: #e6f4ff;
  --submit-background: #bcc4cc;
  --submit-active-background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
  --submit-color: #fff;
  --submit-active-color: #fff;
  --submit-height: 48px;
  --submit-fixed-bottom: calc(env(safe-area-inset-bottom) + 24px);
  --tag-active-color: #ff5526;
  --tag-active-background: #fff3f0;
  --tag-active-border-color: #ff8867;
}

.quark-compass-nps-base {
  --base-title-font-family: pingfangsc-regular, pingfang sc, sans-serif;
  --base-title-font-size: 16px;
  --base-title-font-weight: 500;
  --base-title-line-height: 22px;
  --base-title-color: #111;
  --popup-bg: url(https://m.hellobike.com/resource/helloyun/22871/K24eO_bg.png) left top / 100% auto no-repeat, #fff;
  --container-padding-x: 16px;
  --container-padding-y: 16px;
  --score-active-color: #fff;
  --score-active-background: #fb500a;
  --tag-height: 28px;
  --tag-active-background: #e6f4ff;
  --submit-background: #bcc4cc;
  --submit-active-background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
  --submit-color: #fff;
  --submit-active-color: #fff;
  --submit-height: 48px;
  --submit-fixed-bottom: calc(env(safe-area-inset-bottom) + 24px);
  --tag-active-color: #ff5526;
  --tag-active-background: #fff3f0;
  --tag-active-border-color: #ff8867;
}

.award-no-margin {
  margin-top: 0.9rem;
}

.newCustomer {
  margin: 0 auto 0.1rem auto;
}

.vip-v2-container {
  min-height: 100%;
  background: #f0f4f7;

  .haveData {
    background-image: url('https://m.hellobike.com/resource/gallery/511/VghXUSZP_Group%201707482289.png?x-oss-process=image/quality,q_80');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
    padding-top: 0.04rem;
    margin-top: 0.88rem;
  }

  .feedback-button {
    border-radius: 0.26rem;
    text-align: center;
    position: fixed;
    bottom: 0.76rem;
    right: 0.08rem;
    z-index: 99;
    width: 0.52rem;
    height: 0.52rem;
    background: #fff;
    box-shadow: 0 0.03rem 0.14rem 0 rgba(0, 0, 0, 0.08);
    border: 0.01rem solid #e8d3c2;
    padding: 0.1rem;

    img.icon {
      width: 0.18rem;
      height: 0.18rem;
    }

    .text {
      color: #441d06;
      font-size: 0.11rem;
      height: 0.11rem;
      line-height: 0.07rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
    }
  }

  .header {
    .top-left-line {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      color: #531900;
    }

    .top-right-line {
      height: 0.2rem;

      .go-cs {
        display: flex;
        width: 100%;
        justify-content: flex-end;

        .top-right-word {
          font-size: 0.14rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #531900;
          margin-right: 0.2rem;
          line-height: 0.2rem;

          .prop-button {
            margin-top: -0.02rem;
          }
        }
      }
    }

    .header-menu {
      font-size: 0.12rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      color: rgba(117, 63, 20, 0.7);
      line-height: 0.12rem;
    }
  }

  .total-block {
    width: 97%;
    background-image: url(https://m.hellobike.com/resource/helloyun/08345/RBW4dy3-PN.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;
    height: 1.87rem;
    margin: 0 auto;
    position: relative;

    .total-ali-img {
      img {
        width: 0.54rem;
        height: 0.15rem;
      }

      width: 0.54rem;
      height: 0.15rem;
      position: absolute;
      top: 0.03rem;
      left: 0.06rem;
    }

    .top-img {
      position: absolute;
      right: 0.19rem;
      top: -0.14rem;

      .lottie {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        width: 3.63rem;
        height: 1.87rem;
      }
    }

    .top-one-line {
      display: flex;
      padding: 0.22rem 0 0 0.35rem;

      .top-head-img {
        margin-right: 0.05rem;

        img {
          width: 0.26rem;
          height: 0.26rem;
        }
      }

      .top-hello-word {
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #441d06;
        line-height: 0.27rem;
        margin-right: 0.04rem;
      }

      .top-time {
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: rgba(68, 29, 6, 0.6);
        line-height: 0.27rem;

        .icon {
          margin-bottom: 0.07rem;
          margin-left: 0.03rem;
          width: 0.12rem;
          height: 0.12rem;
          vertical-align: bottom;
        }
      }
    }

    .top-two-line {
      display: flex;
      justify-content: space-between;
      font-size: 0.13rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #441d06;
      line-height: 0.18rem;
      margin-top: 0.1rem;

      .top-left {
        margin-top: 0.04rem;
        margin-left: 0.26rem;
        display: flex;
        line-height: 0.32rem;

        .left-font {
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          margin-top: 0.03rem;
        }

        .red-font {
          font-size: 0.28rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #441d06;
          line-height: 0.32rem;
          background: linear-gradient(180deg, #ff7027 0%, #fb4816 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin: 0 0.01rem;
        }
      }

      .top-right {
        width: 0.81rem;
        height: 0.29rem;
        background: linear-gradient(128deg, #ff9416 0%, #f77740 100%);
        box-shadow: inset 0 0 0.01rem 0 rgba(255, 255, 255, 0.91);
        border-radius: 0.15rem;
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #fffdbd;
        line-height: 0.29rem;
        text-align: center;
        margin-right: 0.32rem;
      }
    }

    .top-list {
      margin: 0.08rem 0.06rem 0 0.15rem;
      overflow: auto;
      display: flex;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }

      .top-item {
        margin-right: 0.11rem;
        width: 0.68rem;

        .top-item-img {
          display: flex;
          width: 0.68rem;

          img {
            margin: 0 auto;
            width: 0.46rem;
            height: 0.46rem;
            opacity: 0.85;
          }
        }

        .top-item-title {
          margin-top: -0.04rem;
          text-align: center;
          font-size: 0.12rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          color: #441d06;
        }

        .top-item-info {
          margin-top: 0.01rem;
          text-align: center;
          transform: scale(0.83);
          font-size: 0.12rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #a54700;
        }
      }
    }
  }

  .award-block {
    margin: 0.9rem 0.1rem 0 0.1rem;
  }

  .awardBlockNew {
    margin-top: 0;
  }

  .plus-gift {
    margin: 0 0.12rem 0.04rem 0.12rem;
  }

  .plus-gift-top {
    margin: 0.08rem 0.12rem -0.02rem 0.12rem;
  }

  .under-block {
    .first-block {
      margin: 0.09rem 0.12rem 0 0.12rem;
      background: #fff;
      box-shadow: 0 0.02rem 0.04rem 0 rgba(241, 241, 241, 0.53);
      border-radius: 0.12rem;
      height: 1.86rem;
      padding: 0.08rem 0 0.14rem 0.12rem;
      position: relative;

      img.first {
        position: absolute;
        top: 0.04rem;
        left: 0.07rem;
        width: 0.22rem;
        height: 0.29rem;
      }

      .first-top-block {
        display: flex;
        justify-content: space-between;

        .first-top-block-title {
          margin-left: 0.26rem;
          font-size: 0.16rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #531900;
        }

        .first-top-block-info {
          padding-right: 0.14rem;
          font-size: 0.13rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #531900;
          line-height: 0.18rem;
          display: flex;

          .red-font {
            font-size: 0.16rem;
            font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
            font-weight: 600;
            color: #fa4614;
            margin: 0 0.01rem;
          }
        }
      }

      .first-bottom-block {
        margin-top: 0.14rem;
        overflow: auto;
        display: flex;
        flex-direction: row;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
          color: transparent;
        }

        .first-list {
          display: flex;

          .first-item {
            width: 0.98rem;
            height: 1.26rem;
            background-image: url(https://m.hellobike.com/resource/helloyun/08345/KC3j3NHDrp.png?x-oss-process=image/quality,q_80);
            background-size: 100% 100%;
            margin-right: 0.1rem;
            position: relative;

            .first-title-block {
              display: flex;
              justify-content: center;
              margin-top: 0.04rem;

              .first-title-block-img {
                img {
                  width: 0.16rem;
                  height: 0.16rem;
                }
              }

              .first-title-block-businessKey {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 0.12rem;
                font-family: PingFangSC-Medium, PingFang SC, sans-serif;
                font-weight: 500;
                color: #531900;
                text-align: center;
                margin-top: 0.01rem;
              }
            }

            .first-money-block {
              text-align: center;
              color: #fa4614;
              height: 0.62rem;
              display: flex;
              justify-content: center;
              margin-top: -0.06rem;

              .bigMoney {
                font-size: 0.28rem;
                font-family: DINAlternate-Bold, DINAlternate, sans-serif;
                font-weight: bold;
                color: #fa4614;
                line-height: 0.44rem;
                margin-top: 0.03rem;
              }

              .smallMoney {
                font-size: 0.16rem;
                font-family: PingFangSC-Medium, PingFang SC, sans-serif;
                font-weight: 500;
                line-height: 0.58rem;
              }

              .moneyUnit {
                font-size: 0.12rem;
                font-family: PingFangSC-Medium, PingFang SC, sans-serif;
                font-weight: 500;
                line-height: 0.58rem;
              }

              .twoPX {
                margin: 0 0.01rem;
              }

              .moneyProp {
                font-size: 0.18rem;
                font-family: DINAlternate-Bold, DINAlternate, sans-serif;
                font-weight: bold;
                line-height: 0.56rem;
              }
            }

            .first-word-block {
              margin-top: -0.24rem;
              font-size: 0.12rem;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: #fa4614;
              text-align: center;
            }

            .first-status {
              position: absolute;
              bottom: 0.06rem;
              height: 0.22rem;
              width: 100%;
              text-align: center;
              font-size: 0.12rem;
              font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
              font-weight: 600;
              color: #531900;
              line-height: 0.22rem;
            }
          }
        }
      }
    }

    .second-block {
      margin: 0.1rem 0.12rem 0.1rem 0.12rem;
      height: 1.89rem;
      background: #fff;
      box-shadow: 0 2px 4px 0 rgba(217, 217, 217, 0);
      border-radius: 0.12rem;
      padding: 0.08rem 0.12rem 0.14rem 0.12rem;
      position: relative;

      img.first-img {
        position: absolute;
        width: 0.22rem;
        height: 0.29rem;
        top: 0.08rem;
        left: 0.07rem;
      }

      .second-top-block {
        display: flex;
        justify-content: space-between;

        .second-top-block-title {
          font-size: 0.16rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #531900;
        }

        .second-top-block-info {
          padding-right: 0.14rem;
          font-size: 0.13rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #531900;
          line-height: 0.18rem;

          .red-font {
            font-size: 0.16rem;
            font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
            font-weight: 600;
            color: #fa4614;
            margin: 0 0.01rem;
          }
        }
      }
    }
  }

  .other-block {
    .other-block-item {
      margin: 0 0.08rem 0.08rem 0.08rem;
      position: relative;

      .other-title-img {
        position: absolute;
        top: 0.06rem;
        left: 0.12rem;

        img.top {
          width: 0.22rem;
          height: 0.29rem;
        }
      }

      .other-title-block {
        position: absolute;
        top: 0.01rem;
        right: 0.04rem;
        width: 1.34rem;
        height: 0.87rem;
      }

      .other-top-line {
        width: 100%;
        height: 0.46rem;
      }

      img.under-img {
        width: 100%;
        object-fit: contain;
        display: block;
      }
    }
  }

  .rule-block {
    text-align: center;
    width: 100%;
    margin: 0 auto;
    font-size: 0.13rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #531900;
    line-height: 0.18rem;
    margin-bottom: 0.28rem;
  }

  .shark-block {
    background: #f4f5f7;
    height: 1rem;
    width: 100%;
  }

  .no-use {
    margin: 0.08rem 0.12rem 0.1rem 0.12rem;
    width: 3.51rem;
    height: 0.5rem;
    background: #fff;
    border-radius: 0.16rem;
    display: flex;
    justify-content: space-between;
    padding: 0.12rem 0.11rem 0.12rem 0.15rem;
    font-family: PingFangSC, PingFang SC, sans-serif;
    font-weight: 500;
    font-size: 0.15rem;
    color: #242729;
    line-height: 0.26rem;

    .no-use-left {
      display: flex;

      img.no-use-img {
        margin-right: 0.03rem;
        width: 0.26rem;
        height: 0.26rem;
      }
    }

    .no-use-right {
      font-family: PingFangSC, PingFang SC, sans-serif;
      font-weight: 400;
      font-size: 0.14rem;
      color: #5a6066;

      img.no-use-flag {
        margin-left: 0.03rem;
        width: 0.1rem;
        height: 0.1rem;
      }
    }

    .black-no-use {
      font-weight: 500;
      font-size: 0.14rem;
      color: #242729;
    }
  }

  .sinan {
    margin: 0 auto 0.08rem auto;
    width: 3.51rem;
    height: 0.4rem;
    background: #fff;
    display: flex;
    line-height: 0.4rem;
    justify-content: space-between;
    border-radius: 0.12rem;
    padding: 0 0.16rem 0 0.1rem;

    .sinan-left {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.13rem;
      font-weight: 400;
      display: flex;

      .left-img {
        margin-top: 0.05rem;

        img {
          width: 0.18rem;
          height: 0.18rem;
        }
      }
    }

    .sinan-right {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.14rem;
      font-weight: 600;

      img {
        margin-top: 0.07rem;
        margin-left: 0.02rem;
        width: 0.12rem;
        height: 0.12rem;
      }
    }
  }

  .coupon-more {
    margin-bottom: 0.1rem;
  }

  .save {
    position: absolute;
    left: 50%;
    top: 1.28rem;
    transform: translateX(-50%);
  }
}

.bikeContainer {
  padding-top: 0.1rem;
}

.new-h5-version {
  .vip-v2-container {
    background: linear-gradient(180deg, #fff 0.337rem, #f0f3f5 1.34rem);
  }
}

.single-vip.new-h5-version {
  .vip-v2-container {
    background: linear-gradient(180deg, #fff4e2 0%, #fff 0.13rem, #f9f9f9 0.337rem);
    border-radius: 0.12rem;
    box-shadow: 0 -0.01rem 0 0 #fff;
  }
}

.single-vip.free-rights-version {
  .vip-v2-container {
    box-shadow: 0 -0.01rem 0 0 #fff;
    border-radius: 0.12rem;
    background: linear-gradient(180deg, #d3e8ff 0%, #fff 0.13rem, #f9f9f9 0.337rem);
  }
}

.free-rights-version {
  background: linear-gradient(181.29deg, #f9f0ec 10%, #f0f3f5 14.91%);
  padding-top: 0;
  padding-bottom: 0;

  .main {
    background: linear-gradient(181.29deg, #f9f0ec 10%, #f0f3f5 14.91%);
  }

  .super-container {
    .haveData {
      .ladder-have-test {
        background-color: #eaeff2;

        .no-use {
          margin: 0.08rem auto 0.1rem;
          padding: 0.12rem 0.21rem 0.12rem 0.093rem;
          width: 3.59rem;
          height: 0.5rem;
          flex-shrink: 0;
          background: #fff;

          .no-use-right {
            display: flex;
            align-items: center;
            color: #5a6066;
            font-size: 0.14rem;
            font-weight: 400;

            img.no-use-flag {
              margin-left: 0.057rem;
              width: 0.04rem;
              height: 0.08rem;
            }
          }
        }

        .shark-block {
          background-color: #141026;
          height: 1.51rem;
        }
      }
    }
  }
}

.openMemberTop {
  margin-top: 0.04rem;
  margin-bottom: 0.2rem;
}

.openMemberTopNoladder {
  margin-top: 0.04rem;
}

.noladder {
  background: #f1f1f1;
}

.vip-v2-nodata {
  min-height: 100vh;
  background: linear-gradient(#fffbeb, #fff);
  padding-top: 0.84rem;
  padding-bottom: 0.74rem;
}

.no-scroll {
  overflow: hidden;
}

.no-data-block {
  height: 100vh;

  .nodata-img {
    padding-top: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .noData {
      margin: 0 auto;
      width: 0.4rem;
      height: 0.4rem;
    }
  }

  .noData-word {
    text-align: center;
    margin-top: 0.18rem;
    font-family: PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 500;
    line-height: 0.17rem;
    color: #879099;
  }
}
</style>
